export type StringsType = Record<StringsKeys, string>;

enum StringsKeys {
  open = "open",
  import = "import",
  french = "french",
  english = "english",
  hello = "hello",
  dashboard = "dashboard",
  createAccount = "createAccount",
  createClient = "createClient",
  prospects = "prospects",
  "pipeline" = "pipeline",
  "possibleMatch" = "possibleMatch",
  "duplicates" = "duplicates",
  individuals = "individuals",
  clientName = "clientName",
  clientEmail = "clientEmail",
  clientPhone = "clientPhone",
  customerSince = "customerSince",
  clientStatus = "clientStatus",
  riskLevel = "riskLevel",
  risk = "risk",
  profileRating = "profileRating",
  consolidatedBalance = "consolidatedBalance",
  folderStatus = "folderStatus",
  completionPercentage = "completionPercentage",
  lastUpdated = "lastUpdated",
  viewDetails = "viewDetails",
  details = "details",
  compare = "compare",
  edit = "edit",
  delete = "delete",
  assignAdvisor = "assignAdvisor",
  updateRiskLevel = "updateRiskLevel",
  searchClients = "searchClients",
  filterByAgency = "filterByAgency",
  filterByStatus = "filterByStatus",
  filterByRiskLevel = "filterByRiskLevel",
  filterByAdvisor = "filterByAdvisor",
  allAgencies = "allAgencies",
  allStatuses = "allStatuses",
  allRiskLevels = "allRiskLevels",
  allAdvisors = "allAdvisors",
  active = "active",
  inactive = "inactive",
  archived = "archived",
  draft = "draft",
  published = "published",
  dormant = "dormant",
  moderate = "moderate",
  high = "high",
  veryHigh = "veryHigh",
  low = "low",
  assigned = "assigned",
  unassigned = "unassigned",
  totalClients = "totalClients",
  activeClients = "activeClients",
  highRiskClients = "highRiskClients",
  unassignedClients = "unassignedClients",
  totalPortfolioValue = "totalPortfolioValue",
  averageProfileRating = "averageProfileRating",
  noClientsFound = "noClientsFound",
  addNewClient = "addNewClient",
  exportData = "exportData",
  refreshData = "refreshData",
  percent = "percent",
  loadingClients = "loadingClients",
  clientDetails = "clientDetails",
  accountInformation = "accountInformation",
  clientInformation = "clientInformation",
  applicantContactDetails = "applicantContactDetails",
  incomeInformation = "incomeInformation",
  accountType = "accountType",
  fullName = "fullName",
  dateOfBirth = "dateOfBirth",
  phone = "phone",
  incomeSource = "incomeSource",
  requiredDocuments = "requiredDocuments",
  documentsPending = "documentsPending",
  uploadAllDocuments = "uploadAllDocuments",
  documentRequired = "documentRequired",
  documentOptional = "documentOptional",
  upload = "upload",
  documentsProcessed = "documentsProcessed",
  progress = "progress",
  loadingDocuments = "loadingDocuments",
  documentLoadingError = "documentLoadingError",
  retryLoadingDocuments = "retryLoadingDocuments",

  // Form Steps
  personalInformation = "personalInformation",
  contactAddressDetails = "contactAddressDetails",
  professionalFamilyInformation = "professionalFamilyInformation",
  professionalInformation = "professionalInformation",
  familyInformation = "familyInformation",
  summary = "summary",

  // Personal Information Fields
  name = "name",
  lastName = "lastName",
  firstName = "firstName",
  motherFullName = "motherFullName",
  nationality = "nationality",
  spokenLanguage = "spokenLanguage",
  gender = "gender",
  male = "male",
  female = "female",
  documentType = "documentType",

  // Contact Details Fields
  mobilePhone = "mobilePhone",
  homePhone = "homePhone",
  countryOfResidence = "countryOfResidence",
  cityMunicipality = "cityMunicipality",
  address = "address",
  postalAddressBP = "postalAddressBP",
  geographicalLandmark = "geographicalLandmark",
  postalBox = "postalBox",
  postalCode = "postalCode",

  // Professional Information Fields
  isOwner = "isOwner",
  monthlyIncome = "monthlyIncome",
  hasOtherIncome = "hasOtherIncome",
  otherIncomeAmount = "otherIncomeAmount",
  professionalCategory = "professionalCategory",
  profession = "profession",
  employer = "employer",
  officePhone = "officePhone",
  educationLevel = "educationLevel",
  maritalStatus = "maritalStatus",
  numberOfChildren = "numberOfChildren",
  partnerFirstName = "partnerFirstName",
  partnerLastName = "partnerLastName",
  fatherLastName = "fatherLastName",
  fatherFirstName = "fatherFirstName",
  motherMaidenName = "motherMaidenName",
  motherFirstName = "motherFirstName",
  countryOfBirth = "countryOfBirth",
  dependents = "dependents",

  // Form Validation Messages
  fieldRequired = "fieldRequired",
  fieldLimited = "fieldLimited",
  validName = "validName",
  phoneNumberInvalid = "phoneNumberInvalid",
  invalidEmailFormat = "invalidEmailFormat",
  mustBeGreaterThanZero = "mustBeGreaterThanZero",
  otherIncomeRequired = "otherIncomeRequired",

  // Form Status Messages
  formCompleteReady = "formCompleteReady",
  formIncompleteReview = "formIncompleteReview",
  formCompleteMessage = "formCompleteMessage",
  formIncompleteMessage = "formIncompleteMessage",
  formSubmittedSuccessfully = "formSubmittedSuccessfully",
  failedToSubmit = "failedToSubmit",
  contactInfoUpdated = "contactInfoUpdated",

  // Navigation
  submit = "submit",
  submitting = "submitting",
  back = "back",

  // Form Steps Description
  personalInfoDescription = "personalInfoDescription",
  contactInfoDescription = "contactInfoDescription",
  professionalInfoDescription = "professionalInfoDescription",
  summaryDescription = "summaryDescription",

  // Currency
  currency = "currency",

  // Placeholders
  placeholderLastName = "placeholderLastName",
  placeholderFirstName = "placeholderFirstName",
  placeholderMotherName = "placeholderMotherName",
  placeholderEmail = "placeholderEmail",
  placeholderAddress = "placeholderAddress",
  placeholderLandmark = "placeholderLandmark",
  placeholderProfession = "placeholderProfession",
  placeholderEmployer = "placeholderEmployer",

  // Cities
  abidjan = "abidjan",
  yamoussoukro = "yamoussoukro",
  bouake = "bouake",
  sanPedro = "sanPedro",
  korhogo = "korhogo",
  man = "man",
  gagnoa = "gagnoa",
  daloa = "daloa",

  // Other
  other = "other",
  notProvided = "notProvided",
  yes = "yes",
  no = "no",
  administration = "administration",
  rolesAndPermissions = "rolesAndPermissions",
  users = "users",
  attestations = "attestations",
  offboarding = "offboarding",
  jitAccess = "jitAccess",
  settings = "settings",
  matrixRBAC = "matrixRBAC",
  rbacMatrixSearchSection = "rbacMatrixSearchSection",
  rbacMatrixSearchHint = "rbacMatrixSearchHint",
  rbacMatrixFilters = "rbacMatrixFilters",
  rbacMatrixFiltersHint = "rbacMatrixFiltersHint",
  rolesAndAttributions = "rolesAndAttributions",
  sodRules = "sodRules",
  adMapping = "adMapping",
  runtimeDecisions = "runtimeDecisions",
  enterprise = "enterprise",
  expired = "expired",
  newRole = "newRole",
  role = "role",
  newRequest = "newRequest",
  publishRole = "publishRole",
  publishRoleAttestation = "publishRoleAttestation",
  publishingRole = "publishingRole",
  rolePublishedSuccess = "rolePublishedSuccess",
  rolePublishedError = "rolePublishedError",
  confirmPublishRoleTitle = "confirmPublishRoleTitle",
  confirmPublishRoleDescription = "confirmPublishRoleDescription",
  simulateUser = "simulateUser",
  mapAD = "mapAD",
  save = "save",
  search = "search",
  selectValue = "selectValue",
  searchValue = "searchValue",
  noValueFound = "noValueFound",
  prospectsSearch = "prospectsSearch",
  prospectsSearchSection = "prospectsSearchSection",
  prospectsSearchFilters = "prospectsSearchFilters",
  prospectsSearchFiltersHint = "prospectsSearchFiltersHint",
  prospectsShowFilters = "prospectsShowFilters",
  prospectsHideFilters = "prospectsHideFilters",
  // Filtre statut de l'ecran prospects. Miroir des trois valeurs que le back accepte sur
  // GET /customers/prospects ; sans filtre, il rend les prospects seuls.
  statusProspect = "statusProspect",
  statusPendingScreening = "statusPendingScreening",
  statusRefused = "statusRefused",
  // Aide de l'ecran : ce que chaque statut veut dire, les trois n'etant pas des etapes d'une
  // meme progression - un dossier refuse peut etre remis a l'etude.
  statusFilterHelp = "statusFilterHelp",
  statusProspectHint = "statusProspectHint",
  statusPendingScreeningHint = "statusPendingScreeningHint",
  statusRefusedHint = "statusRefusedHint",
  // Aide du filtre segment : ce que recouvrent personne physique et personne morale.
  typeFilterHelp = "typeFilterHelp",
  physicalPersonHint = "physicalPersonHint",
  legalPersonHint = "legalPersonHint",
  // Aide du filtre canal : par quelle voie le dossier est entre en relation.
  channelFilterHelp = "channelFilterHelp",
  channelDigitalHint = "channelDigitalHint",
  channelAgencyHint = "channelAgencyHint",
  channelCbsImportHint = "channelCbsImportHint",
  // Filtre periode : intitule et aide. Les deux bornes sont incluses et attendues ensemble.
  periodCreated = "periodCreated",
  periodFilterHelp = "periodFilterHelp",
  periodFilterHint = "periodFilterHint",
  // Filtre canal d'entree en relation. Miroir de l'enumeration OnboardingChannel du back.
  channelDigital = "channelDigital",
  channelAgency = "channelAgency",
  channelCbsImport = "channelCbsImport",
  reset = "reset",
  results = "results",
  criticality = "criticality",
  frequency = "frequency",
  sod = "sod",
  help = "help",
  views = "views",
  generalInformation = "generalInformation",
  prefilledFromCreationStep = "prefilledFromCreationStep",
  matrixViewDescription = "matrixViewDescription",
  usersDescription = "usersDescription",
  usersSearchHint = "usersSearchHint",
  roleAndOwner = "roleAndOwner",
  none = "none",
  twoSod = "twoSod",
  consult = "consult",
  modify = "modify",
  approve = "approve",
  export = "export",
  compliance = "compliance",
  credit = "credit",
  gdpr = "gdpr",
  linesPerPage = "linesPerPage",
  pageInfo = "pageInfo",
  notifications = "notifications",
  noNotifications = "noNotifications",
  noNotificationsHint = "noNotificationsHint",
  notificationsUnread = "notificationsUnread",
  notificationsTabAll = "notificationsTabAll",
  notificationsTabUnread = "notificationsTabUnread",
  notificationsEmptyUnread = "notificationsEmptyUnread",
  notificationsToday = "notificationsToday",
  notificationsYesterday = "notificationsYesterday",
  notificationsEarlier = "notificationsEarlier",
  markAllAsRead = "markAllAsRead",

  // Form Steps Title
  formSteps = "formSteps",
  fillInInformation = "fillInInformation",

  // Error Messages
  pleaseFixErrors = "pleaseFixErrors",

  // Step Status
  current = "current",
  completed = "completed",
  pending = "pending",
  error = "error",

  failedGettingUserRole = "failedGettingUserRole",
  backToHome = "backToHome",
  pageNotFound = "pageNotFound",
  weCouldNotFindThePageYouAreLookingFor = "WeCouldNotFindThePageYouAreLookingFor",
  internalServerError = "internalServerError",
  oopsSomethingWentWrong = "oopsSomethingWentWrong",
  youAreNotAuthorized = "youAreNotAuthorized",
  youDonTHavePermissionToAccessThisPage = "youDonTHavePermissionToAccessThisPage",
  permissionDeniedPageDescription = "permissionDeniedPageDescription",
  welcomeTo = "welcomeTo",
  pleaseSignIn = "pleaseSignIn",
  password = "password",
  rememberMe = "rememberMe",
  loginHeroTitle = "loginHeroTitle",
  loginHeroSubtitle = "loginHeroSubtitle",
  loginSecurityNote = "loginSecurityNote",
  loginFormSecurityNote = "loginFormSecurityNote",
  loginHelperText = "loginHelperText",
  loginEmailPlaceholder = "loginEmailPlaceholder",
  credentials = "credentials",
  badCredentials = "badCredentials",
  emailOrPasswordInvalid = "emailOrPasswordInvalid",
  forgotPassword = "forgotPassword",
  login = "login",
  firstLoginResetTitle = "firstLoginResetTitle",
  firstLoginResetSubtitle = "firstLoginResetSubtitle",
  currentPassword = "currentPassword",
  newPasswordChoice = "newPasswordChoice",
  confirmNewPassword = "confirmNewPassword",
  passwordsDoNotMatch = "passwordsDoNotMatch",
  passwordResetSuccess = "passwordResetSuccess",
  passwordResetSuccessReconnectHint = "passwordResetSuccessReconnectHint",
  changePassword = "changePassword",
  passwordStrengthWeak = "passwordStrengthWeak",
  passwordStrengthFair = "passwordStrengthFair",
  passwordStrengthGood = "passwordStrengthGood",
  passwordStrengthStrong = "passwordStrengthStrong",
  passwordStrengthHint = "passwordStrengthHint",
  passwordRequirementMinLength = "passwordRequirementMinLength",
  passwordRequirementUppercase = "passwordRequirementUppercase",
  passwordRequirementLowercase = "passwordRequirementLowercase",
  passwordRequirementDigit = "passwordRequirementDigit",
  passwordRequirementSpecial = "passwordRequirementSpecial",
  passwordConfirmMatches = "passwordConfirmMatches",
  passwordMustDifferFromCurrent = "passwordMustDifferFromCurrent",
  inputLogin = "inputLogin",
  newOnOurPlatform = "newOnOurPlatform",
  createAnAccount = "createAnAccount",
  or = "or",
  errorOccurred = "errorOccurred",
  unexpectedOrNetworkError = "unexpectedOrNetworkError",
  unauthorizedAction = "unauthorizedAction",
  subscriptionRequired = "subscriptionRequired",
  resourceNotFound = "resourceNotFound",
  invalidInfos = "invalidInfos",
  conflictEncountered = "conflictEncountered",
  unavailableServer = "unavailableServer",
  logoutFailed = "logoutFailed",
  logout = "logout",
  sessionExpired = "sessionExpired",
  sessionExpiredMessage = "sessionExpiredMessage",
  externalResourceUnavailable = "externalResourceUnavailable",
  unexpectedError = "unexpectedError",
  requiredField = "requiredField",
  invalidEmail = "invalidEmail",
  invalidPassword = "invalidPassword",
  email = "email",
  failed = "failed",
  userAvatar = "userAvatar",
  operationFailed = "operationFailed",
  clientDataNotAvailable = "clientDataNotAvailable",
  FailedToLogoutUser = "FailedToLogoutUser",
  tryAgain = "tryAgain",
  activities = "activities",
  customers = "customers",
  professionals = "professionals",
  products = "products",
  inquirie_create_client = "inquirie_create_client",
  inquiries = "inquiries",
  inquirie = "inquirie",
  folders = "folders",
  marketing = "marketing",
  atm = "atm",
  period = "period",
  day = "day",
  week = "week",
  month = "month",
  trimester = "trimester",
  semester = "semester",
  year = "year",
  compareToPreviousDay = "compareToPreviousDay",
  compareToPreviousWeek = "compareToPreviousWeek",
  compareToPreviousMonth = "compareToPreviousMonth",
  compareToPreviousTrimester = "compareToPreviousTrimester",
  compareToPreviousSemester = "compareToPreviousSemester",
  compareToPreviousYear = "compareToPreviousYear",
  client = "client",
  client360 = "client360",
  client360SearchFilters = "client360SearchFilters",
  client360SearchFiltersHint = "client360SearchFiltersHint",
  client360SearchSection = "client360SearchSection",
  client360ShowFilters = "client360ShowFilters",
  client360HideFilters = "client360HideFilters",
  agency = "agency",
  advisorName = "advisorName",
  since = "since",
  profile = "profile",
  totalBalance = "totalBalance",
  actions = "actions",
  columns = "columns",
  noResults = "noResults",
  selectedRows = "selectedRows",
  previous = "previous",
  paginationPageSize = "paginationPageSize",
  paginationPageInfo = "paginationPageInfo",
  next = "next",
  advancedFilters = "advancedFilters",
  kpi = "kpi",
  clear = "clear",
  call = "call",
  activity = "activity",
  accountsProducts = "accountsProducts",
  transactions = "transactions",
  analyse = "analyse",
  informations = "informations",
  notesInteractions = "notesInteractions",
  documents = "documents",
  networkError = "networkError",
  customersPerPage = "customersPerPage",
  loading = "loading",
  signature = "signature",
  clientSince = "clientSince",
  placeOfBirth = "placeOfBirth",
  documentNumber = "documentNumber",
  dateOfIssue = "dateOfIssue",
  countryOfIssue = "countryOfIssue",
  placeOfDelivery = "placeOfDelivery",
  documentReference = "documentReference",
  identityDocumentType = "identityDocumentType",
  identityDocumentNumber = "identityDocumentNumber",
  nationalIdNumber = "nationalIdNumber",
  expiryDate = "expiryDate",
  validatedPart = "validatedPart",
  completionLevel = "completionLevel",

  // RBAC Matrix - Additional keys
  medium = "medium",
  dependencies = "dependencies",
  nbPermissions = "nbPermissions",
  rulesManagement = "rulesManagement",
  newRule = "newRule",
  ruleName = "ruleName",
  ruleDescription = "ruleDescription",
  noRulesFound = "noRulesFound",
  invalidPhoneFormat = "invalidPhoneFormat",

  // User
  user = "user",
  state = "state",
  presence = "presence",
  backup = "backup",
  permissions = "permissions",

  // Documents
  category = "category",
  date = "date",
  send = "send",
  download = "download",
  documentDownloaded = "documentDownloaded",
  documentDownloadError = "documentDownloadError",
  documentPreviewTitle = "documentPreviewTitle",
  documentPreviewError = "documentPreviewError",
  documentPreviewNotSupported = "documentPreviewNotSupported",
  screeningReportDownloaded = "screeningReportDownloaded",
  screeningReportDownloadError = "screeningReportDownloadError",
  documentPerPage = "documentPerPage",
  // Demandes - Selection manuelle UI
  filters = "filters",
  channel = "channel",
  country = "country",
  segment = "segment",
  availableRequests = "availableRequests",
  continue = "continue",
  requiredFields = "requiredFields",
  missingFields = "missingFields",
  // Request items
  request_create_account = "request_create_account",
  request_create_account_desc = "request_create_account_desc",
  request_onboarding_a2 = "request_onboarding_a2",
  request_onboarding_a2_desc = "request_onboarding_a2_desc",
  request_regen_otp = "request_regen_otp",
  request_regen_otp_desc = "request_regen_otp_desc",
  request_secure_upload_reminder = "request_secure_upload_reminder",
  request_secure_upload_reminder_desc = "request_secure_upload_reminder_desc",
  request_id_replacement = "request_id_replacement",
  request_id_replacement_desc = "request_id_replacement_desc",
  request_address_change = "request_address_change",
  request_address_change_desc = "request_address_change_desc",
  request_four_eyes = "request_four_eyes",
  request_four_eyes_desc = "request_four_eyes_desc",
  request_rekcy = "request_rekcy",
  request_rekcy_desc = "request_rekcy_desc",
  request_export_kpi = "request_export_kpi",
  request_export_kpi_desc = "request_export_kpi_desc",
  request_contact_update = "request_contact_update",
  request_contact_update_desc = "request_contact_update_desc",
  request_account_closure = "request_account_closure",
  request_account_closure_desc = "request_account_closure_desc",
  request_add_proxy = "request_add_proxy",
  request_add_proxy_desc = "request_add_proxy_desc",
  request_pep_declaration = "request_pep_declaration",
  request_pep_declaration_desc = "request_pep_declaration_desc",
  request_civil_status_change = "request_civil_status_change",
  request_civil_status_change_desc = "request_civil_status_change_desc",
  request_add_legal_representative = "request_add_legal_representative",
  request_add_legal_representative_desc = "request_add_legal_representative_desc",
  request_income_employer_update = "request_income_employer_update",
  request_income_employer_update_desc = "request_income_employer_update_desc",
  request_family_situation_change = "request_family_situation_change",
  request_family_situation_change_desc = "request_family_situation_change_desc",
  request_create_prospect = "request_create_prospect",
  request_create_prospect_desc = "request_create_prospect_desc",
  demandes = "demandes",
  nouvelleDemande = "nouvelleDemande",

  // Prospects
  type = "type",
  contact = "contact",
  accessStatus = "accessStatus",
  canal = "canal",
  screening = "screening",
  additionalDocuments = "additionalDocuments",
  lastUpdate = "lastUpdate",
  createdAt = "createdAt",

  birthDate = "birthDate",
  notes = "notes",
  motif = "motif",
  address1 = "address1",
  address2 = "address2",
  city = "city",
  deliveredDate = "deliveredDate",
  IdDocType = "IdDocType",
  IdDocNumber = "IdDocNumber",
  birthPlace = "birthPlace",

  // Onboarding
  identification = "identification",
  update = "update",
  editable = "editable",
  readOnly = "readOnly",

  // client
  clients = "clients",
  selectClient = "selectClient",
  selectClientDescription = "selectClientDescription",
  clientSearch = "clientSearch",
  sensitiveClientsFilter = "sensitiveClientsFilter",
  sensitiveFilterAll = "sensitiveFilterAll",
  sensitiveFilterWithout = "sensitiveFilterWithout",
  sensitiveFilterWith = "sensitiveFilterWith",
  kyc = "kyc",
  partyid = "partyid",
  account = "account",

  synthese = "synthese",
  risqueReKyc = "risqueReKyc",
  scoringProfilTitle = "scoringProfilTitle",
  scoringScore = "scoringScore",
  scoringDeclencheurs = "scoringDeclencheurs",
  scoringVoirDetails = "scoringVoirDetails",
  scoringPolitiqueRisque = "scoringPolitiqueRisque",
  scoringNotCalculated = "scoringNotCalculated",
  scoringClasseDeRisque = "scoringClasseDeRisque",
  scoringNonCalcule = "scoringNonCalcule",
  scoringTrackA = "scoringTrackA",
  scoringTrackB = "scoringTrackB",
  scoringCombined = "scoringCombined",
  scoringDecision = "scoringDecision",
  scoringCompleteness = "scoringCompleteness",
  scoringScoredAt = "scoringScoredAt",
  scoringScoredBy = "scoringScoredBy",
  scoringTrigger = "scoringTrigger",
  scoringFactorsTitle = "scoringFactorsTitle",
  scoringLoadError = "scoringLoadError",
  scoringClassification = "scoringClassification",
  scoringRawScore = "scoringRawScore",
  scoringWeight = "scoringWeight",
  scoringHardOverrides = "scoringHardOverrides",
  scoringEntity = "scoringEntity",
  scoringEntityLabel = "scoringEntityLabel",
  scoringLevel = "scoringLevel",
  scoringPoints = "scoringPoints",
  accounts = "accounts",
  /** Singulier, pour les compteurs a une unite. `account` est deja pris par un en-tete de colonne. */
  accountSingular = "accountSingular",
  consents = "consents",
  timeline = "timeline",
  fiche = "fiche",

  // Create Prospect Page
  createProspectPhysicalPersonTitle = "createProspectPhysicalPersonTitle",
  requiredInformation = "requiredInformation",
  optionalInformation = "optionalInformation",
  physicalPerson = "physicalPerson",
  sex = "sex",
  masculine = "masculine",
  feminine = "feminine",
  selectOption = "selectOption",
  cni = "cni",
  passport = "passport",
  drivingLicense = "drivingLicense",
  notesOptional = "notesOptional",
  dateFormat = "dateFormat",
  errorCreatingProspect = "errorCreatingProspect",
  prospectCreatedSuccessfully = "prospectCreatedSuccessfully",
  prospectCreatedRedirectMessage = "prospectCreatedRedirectMessage",
  requiredFieldsDisclaimer = "requiredFieldsDisclaimer",
  cancel = "cancel",
  create = "create",
  creating = "creating",
  idType = "idType",
  idNumber = "idNumber",
  issueDate = "issueDate",
  addressLine1 = "addressLine1",
  addressLine2 = "addressLine2",

  // New prospect form keys
  civilite = "civilite",
  genre = "genre",
  masculineShort = "masculineShort",
  feminineShort = "feminineShort",
  mr = "mr",
  mrs = "mrs",
  miss = "miss",
  mobile = "mobile",
  sendOTP = "sendOTP",
  OTPSent = "OTPSent",
  verifyOTP = "verifyOTP",
  otpCode = "otpCode",
  productOfInterest = "productOfInterest",
  productsOfInterest = "productsOfInterest",
  intentComment = "intentComment",
  intentCommentPlaceholder = "intentCommentPlaceholder",
  createProspectAccountObject = "createProspectAccountObject",
  wantsContactForProducts = "wantsContactForProducts",
  validateAndContinue = "validateAndContinue",
  startOnboarding = "startOnboarding",
  coordinatesAndIntent = "coordinatesAndIntent",
  notesAndMentions = "notesAndMentions",
  requestContext = "requestContext",
  what = "what",
  produit = "produit",
  notDefined = "notDefined",
  characterLimit = "characterLimit",
  chooseOption = "chooseOption",
  carte = "carte",
  epargne = "epargne",
  compteAVueXOF = "compteAVueXOF",
  suivant = "suivant",

  rm = "rm",
  relationshipManager = "relationshipManager",

  prospectCreated = "prospectCreated",
  prospectCreatedModalDescription = "prospectCreatedModalDescription",
  prospectCreatedModalDescriptionPm = "prospectCreatedModalDescriptionPm",
  clientCreated = "clientCreated",
  clientCreatedModalDescription = "clientCreatedModalDescription",
  nextStep = "nextStep",
  verifyRequiredDocuments = "verifyRequiredDocuments",
  confirmConsents = "confirmConsents",
  goToProspectList = "goToProspectList",
  continueOnboarding = "continueOnboarding",
  continueClientProfile = "continueClientProfile",
  accessToClientProfile = "accessToClientProfile",
  generateClientAccess = "generateClientAccess",
  pepOnboardingSubmittedTitle = "pepOnboardingSubmittedTitle",
  pepOnboardingSubmittedDescription = "pepOnboardingSubmittedDescription",
  pepOnboardingComplianceFourEyesMessage = "pepOnboardingComplianceFourEyesMessage",
  pepOnboardingAccountCreationPendingMessage = "pepOnboardingAccountCreationPendingMessage",
  createNewProspect = "createNewProspect",
  onboardingGate_loading = "onboardingGate_loading",
  onboardingGate_error = "onboardingGate_error",
  onboardingGate_unavailable = "onboardingGate_unavailable",
  onboardingGate_pass_banner = "onboardingGate_pass_banner",
  onboardingGate_outcome_created = "onboardingGate_outcome_created",
  onboardingGate_sanctions = "onboardingGate_sanctions",
  onboardingGate_pep = "onboardingGate_pep",
  onboardingGate_screeningInProgress = "onboardingGate_screeningInProgress",
  onboardingGate_softPass = "onboardingGate_softPass",
  onboardingGate_outcome_createdRouted = "onboardingGate_outcome_createdRouted",
  onboardingGate_routedReview = "onboardingGate_routedReview",
  onboardingGate_refresh = "onboardingGate_refresh",
  onboardingGate_routed_title = "onboardingGate_routed_title",
  onboardingGate_sanctions_title = "onboardingGate_sanctions_title",

  onlyLetters = "onlyLetters",
  identityInformation = "identityInformation",
  companyIdentityInformation = "companyIdentityInformation",
  declarantContact = "declarantContact",
  companyName = "companyName",
  registrationNumberOptional = "registrationNumberOptional",
  contactPersonName = "contactPersonName",

  onboarding = "onboarding",
  productIntent = "productIntent",
  backgroundToRequest = "backgroundToRequest",
  infosIntent = "infosIntent",
  addressProfile = "addressProfile",
  salaryAmount = "salaryAmount",
  activitySector = "activitySector",
  stepEntreprise = "stepEntreprise",
  legalIdentificationKyb = "legalIdentificationKyb",
  addressAndContact = "addressAndContact",
  tradeName = "tradeName",
  companyPhone = "companyPhone",
  companyEmail = "companyEmail",
  legalForm = "legalForm",
  registrationNumber = "registrationNumber",
  taxId = "taxId",
  incorporationCountry = "incorporationCountry",
  incorporationDate = "incorporationDate",
  shareCapital = "shareCapital",
  headOfficeAddress = "headOfficeAddress",
  corporateObject = "corporateObject",
  legalFormSarl = "legalFormSarl",
  legalFormSa = "legalFormSa",
  legalFormSas = "legalFormSas",
  legalFormGie = "legalFormGie",
  legalFormHolding = "legalFormHolding",
  legalFormAssociation = "legalFormAssociation",
  legalFormPublicEntity = "legalFormPublicEntity",
  sectorCommerce = "sectorCommerce",
  sectorAgriculture = "sectorAgriculture",
  sectorConstruction = "sectorConstruction",
  sectorRealEstate = "sectorRealEstate",
  sectorForeignExchange = "sectorForeignExchange",
  sectorGambling = "sectorGambling",
  sectorFinancialServices = "sectorFinancialServices",
  sectorTransport = "sectorTransport",
  saveSuccessful = "saveSuccessful",
  saveFailed = "saveFailed",
  stepRepresentants = "stepRepresentants",
  addRepresentative = "addRepresentative",
  removeRepresentative = "removeRepresentative",
  activeSignatoryBlocksRemoval = "activeSignatoryBlocksRemoval",
  alreadyKnownInSystem = "alreadyKnownInSystem",
  representativesListTitle = "representativesListTitle",
  showDetails = "showDetails",
  hideDetails = "hideDetails",
  addedOn = "addedOn",
  identitySource = "identitySource",
  sourceAgentInput = "sourceAgentInput",
  sourceRicProjection = "sourceRicProjection",
  rolesHeld = "rolesHeld",
  addRole = "addRole",
  removeRole = "removeRole",
  lastRoleCannotBeRemoved = "lastRoleCannotBeRemoved",
  noRoleToAdd = "noRoleToAdd",
  searchExistingPerson = "searchExistingPerson",
  searchPersonPlaceholder = "searchPersonPlaceholder",
  noResultsFound = "noResultsFound",
  manualEntry = "manualEntry",
  chooseRole = "chooseRole",
  possibleMatchesFound = "possibleMatchesFound",
  matchTypeExact = "matchTypeExact",
  matchTypePartial = "matchTypePartial",
  reuseThisPerson = "reuseThisPerson",
  confirmDifferentPerson = "confirmDifferentPerson",
  representativeAddedSuccess = "representativeAddedSuccess",
  removalNotSupportedYet = "removalNotSupportedYet",
  alreadyLinkedRoles = "alreadyLinkedRoles",
  functionGerant = "functionGerant",
  functionDG = "functionDG",
  functionPDG = "functionPDG",
  functionPresident = "functionPresident",
  functionAdministrateur = "functionAdministrateur",
  residenceCountry = "residenceCountry",
  identityDocumentSectionTitle = "identityDocumentSectionTitle",
  runOcr = "runOcr",
  uploadDocumentToContinue = "uploadDocumentToContinue",
  representativeDocumentType = "representativeDocumentType",
  documentTypeCNI = "documentTypeCNI",
  documentTypePassport = "documentTypePassport",
  documentTypeResidencePermit = "documentTypeResidencePermit",
  mandateSectionTitle = "mandateSectionTitle",
  mandateReference = "mandateReference",
  mandateType = "mandateType",
  mandateStartDate = "mandateStartDate",
  mandateEndDate = "mandateEndDate",
  mandateCertifiedDocument = "mandateCertifiedDocument",
  mandateTypeStatutory = "mandateTypeStatutory",
  mandateTypeProxy = "mandateTypeProxy",
  mandateTypeDelegation = "mandateTypeDelegation",
  mandateTypeBankMandate = "mandateTypeBankMandate",
  stepActionnariat = "stepActionnariat",
  significantShareholdersQuestion = "significantShareholdersQuestion",
  addShareholder = "addShareholder",
  removeShareholder = "removeShareholder",
  personTypePP = "personTypePP",
  personTypePM = "personTypePM",
  percentageHeldLabel = "percentageHeldLabel",
  shareholderLegalName = "shareholderLegalName",
  shareholderRegistryNumber = "shareholderRegistryNumber",
  uboEffectifLabel = "uboEffectifLabel",
  belowUboThresholdLabel = "belowUboThresholdLabel",
  shareholdingSumError = "shareholdingSumError",
  completeRequiredFieldsMessage = "completeRequiredFieldsMessage",
  controlGraphTitle = "controlGraphTitle",
  exportGraph = "exportGraph",
  exportComingSoon = "exportComingSoon",
  shareholderIdentificationDate = "shareholderIdentificationDate",
  shareholderLastVerificationDate = "shareholderLastVerificationDate",
  shareholderProofSource = "shareholderProofSource",
  legendPpIdentified = "legendPpIdentified",
  legendPmIntermediary = "legendPmIntermediary",
  legendBelowThreshold = "legendBelowThreshold",

  // Documents step (PM onboarding)
  stepDocuments = "stepDocuments",
  documentChecklistTitle = "documentChecklistTitle",
  documentChecklistDescription = "documentChecklistDescription",
  documentChecklistLoading = "documentChecklistLoading",
  documentChecklistEmpty = "documentChecklistEmpty",
  documentProvided = "documentProvided",
  documentRequiredBadge = "documentRequiredBadge",
  documentChecklistIncompleteMessage = "documentChecklistIncompleteMessage",
  documentTypeStatuts = "documentTypeStatuts",
  documentTypeRccm = "documentTypeRccm",
  documentTypePieceIdentiteRl = "documentTypePieceIdentiteRl",
  documentTypeNominationDirigeants = "documentTypeNominationDirigeants",
  documentTypeDeclarationBeneficiairesEffectifs = "documentTypeDeclarationBeneficiairesEffectifs",
  documentTypeConventionGie = "documentTypeConventionGie",
  documentTypeRecepisseDeclaration = "documentTypeRecepisseDeclaration",

  // Screening step (PM onboarding)
  stepScreening = "stepScreening",
  pmScreeningTitle = "pmScreeningTitle",
  pmScreeningDescription = "pmScreeningDescription",
  pmScreeningLaunchButton = "pmScreeningLaunchButton",
  pmScreeningRunning = "pmScreeningRunning",
  pmScreeningNoHitsMessage = "pmScreeningNoHitsMessage",
  pmScreeningUnqualifiedHitsBlockMessage = "pmScreeningUnqualifiedHitsBlockMessage",
  pmScreeningEntityTypeEntreprise = "pmScreeningEntityTypeEntreprise",
  pmScreeningEntityTypeActionnaire = "pmScreeningEntityTypeActionnaire",
  pmScreeningEntityTypeRepresentant = "pmScreeningEntityTypeRepresentant",
  pmScreeningListSourceSanctions = "pmScreeningListSourceSanctions",
  pmScreeningListSourcePep = "pmScreeningListSourcePep",
  pmScreeningListSourceAdverseMedia = "pmScreeningListSourceAdverseMedia",
  pmScreeningQualifyTruePositive = "pmScreeningQualifyTruePositive",
  pmScreeningQualifyFalsePositive = "pmScreeningQualifyFalsePositive",
  pmScreeningQualificationPending = "pmScreeningQualificationPending",
  pmScreeningQualificationTruePositive = "pmScreeningQualificationTruePositive",
  pmScreeningQualificationFalsePositive = "pmScreeningQualificationFalsePositive",

  // Risk score step (PM onboarding)
  stepRiskScore = "stepRiskScore",
  riskScoreTitle = "riskScoreTitle",
  riskScoreDescription = "riskScoreDescription",
  riskScoreLoading = "riskScoreLoading",
  riskScoreCompositeLabel = "riskScoreCompositeLabel",
  riskScoreLevelLabel = "riskScoreLevelLabel",
  riskScoreFactorsTitle = "riskScoreFactorsTitle",
  riskScoreVigilanceMessage = "riskScoreVigilanceMessage",
  riskLevelFaible = "riskLevelFaible",
  riskLevelModere = "riskLevelModere",
  riskLevelEleve = "riskLevelEleve",
  riskFactorBase = "riskFactorBase",
  riskFactorSensitiveSector = "riskFactorSensitiveSector",
  riskFactorPepRepresentative = "riskFactorPepRepresentative",
  riskFactorScreeningHit = "riskFactorScreeningHit",

  // DÃ©cision step (PM onboarding)
  stepDecision = "stepDecision",
  decisionTitle = "decisionTitle",
  decisionMakerNameLabel = "decisionMakerNameLabel",
  decisionOutcomeLabel = "decisionOutcomeLabel",
  decisionJustificationLabel = "decisionJustificationLabel",
  decisionOutcomeApprovedComplete = "decisionOutcomeApprovedComplete",
  decisionOutcomeApprovedWithRestrictions = "decisionOutcomeApprovedWithRestrictions",
  decisionOutcomeRequestAdditionalInfo = "decisionOutcomeRequestAdditionalInfo",
  decisionOutcomeRegulatoryHold = "decisionOutcomeRegulatoryHold",

  // Account opening step (PM onboarding)
  stepAccountOpening = "stepAccountOpening",
  accountOpeningTitle = "accountOpeningTitle",
  accountOpeningRecapCompanyName = "accountOpeningRecapCompanyName",
  accountOpeningRecapLegalForm = "accountOpeningRecapLegalForm",
  accountOpeningRecapRepresentatives = "accountOpeningRecapRepresentatives",
  accountOpeningRecapShareholders = "accountOpeningRecapShareholders",
  accountOpeningRecapScreening = "accountOpeningRecapScreening",
  accountOpeningRecapRiskLevel = "accountOpeningRecapRiskLevel",
  accountOpeningRecapDecision = "accountOpeningRecapDecision",
  accountOpeningBlockedMessage = "accountOpeningBlockedMessage",
  accountOpeningCreateButton = "accountOpeningCreateButton",
  accountOpeningConfirmTitle = "accountOpeningConfirmTitle",
  accountOpeningConfirmDescription = "accountOpeningConfirmDescription",
  accountOpeningConfirmAction = "accountOpeningConfirmAction",
  accountOpeningSuccessMessage = "accountOpeningSuccessMessage",
  accountOpeningAccountNumberLabel = "accountOpeningAccountNumberLabel",
  accountOpeningSignatoriesLabel = "accountOpeningSignatoriesLabel",

  // Evidence pack step (PM onboarding)
  stepEvidencePack = "stepEvidencePack",
  evidencePackTitle = "evidencePackTitle",
  evidencePackDescription = "evidencePackDescription",
  evidencePackGenerateButton = "evidencePackGenerateButton",
  evidencePackLoading = "evidencePackLoading",
  evidencePackComplianceStatement = "evidencePackComplianceStatement",
  evidencePackReferenceLabel = "evidencePackReferenceLabel",
  evidencePackGeneratedAtLabel = "evidencePackGeneratedAtLabel",
  evidencePackNextReviewDateLabel = "evidencePackNextReviewDateLabel",
  evidencePackDownloadButton = "evidencePackDownloadButton",
  evidencePackRegenerateButton = "evidencePackRegenerateButton",

  request = "request",
  partsApproval = "partsApproval",
  metadataOcr = "metadataOcr",
  summaryValidation = "summaryValidation",
  reviewSummaryTitle = "reviewSummaryTitle",
  verifyBeforeCreate = "verifyBeforeCreate",
  screeningAndProfile = "screeningAndProfile",
  screeningRule = "screeningRule",
  screeningDetail = "screeningDetail",
  noScreeningRules = "noScreeningRules",
  screeningRulesPending = "screeningRulesPending",
  screeningRulesUnavailable = "screeningRulesUnavailable",
  screeningProvider = "screeningProvider",
  screeningAdvisoryNotice = "screeningAdvisoryNotice",
  screeningExternalNotStarted = "screeningExternalNotStarted",
  screeningExternalPending = "screeningExternalPending",
  riskFactorsTitle = "riskFactorsTitle",
  riskFactorsDecisive = "riskFactorsDecisive",
  riskFactorsOthers = "riskFactorsOthers",
  riskFactorsScore = "riskFactorsScore",
  riskFactorsCompleteness = "riskFactorsCompleteness",
  riskFactorsHardOverride = "riskFactorsHardOverride",
  riskFactorsUnavailable = "riskFactorsUnavailable",
  riskFactorNotApplicable = "riskFactorNotApplicable",
  riskFactorUnknownCode = "riskFactorUnknownCode",
  riskFactorNoValue = "riskFactorNoValue",
  riskFactorsColEntity = "riskFactorsColEntity",
  riskFactorsColValue = "riskFactorsColValue",
  riskFactorsColLevel = "riskFactorsColLevel",
  riskFactorsColPoints = "riskFactorsColPoints",
  riskFactorsAssessedEntities = "riskFactorsAssessedEntities",
  status = "status",

  // Result Screening
  SANCTIONS_PEP = "SANCTIONS_PEP",
  ELIGIBILITE_EXTERNE = "ELIGIBILITE_EXTERNE",
  screeningStatus_clean_label = "screeningStatus_clean_label",
  screeningStatus_pending_label = "screeningStatus_pending_label",
  screeningStatus_reject_label = "screeningStatus_reject_label",
  COMPLETUDE = "COMPLETUDE",
  OCR_QUALITE = "OCR_QUALITE",
  COHERENCE_IDENTITE = "COHERENCE_IDENTITE",
  RISQUE_INITIAL = "RISQUE_INITIAL",

  // Screening step & OCR
  ocrExtractionTitle = "ocrExtractionTitle",
  ocrExtractionDescription = "ocrExtractionDescription",
  ocrStatusInProgress = "ocrStatusInProgress",
  ocrStatusFailed = "ocrStatusFailed",
  ocrStatusReady = "ocrStatusReady",
  screeningInvalidIdTitle = "screeningInvalidIdTitle",
  screeningInvalidIdDescription = "screeningInvalidIdDescription",
  screeningInvalidIdInline = "screeningInvalidIdInline",
  ocrApplyButton = "ocrApplyButton",
  ocrApplyButtonLoading = "ocrApplyButtonLoading",

  // OCR sections
  ocrAddressContactTitle = "ocrAddressContactTitle",
  ocrIdentityTitle = "ocrIdentityTitle",
  ocrDocumentDetailsTitle = "ocrDocumentDetailsTitle",
  ocrDocumentDetailsDescription = "ocrDocumentDetailsDescription",
  ocrFamilyTitle = "ocrFamilyTitle",
  ocrProfessionalTitle = "ocrProfessionalTitle",
  ocrAdditionalFieldsTitle = "ocrAdditionalFieldsTitle",
  placeholderPaysProfessionExample = "placeholderPaysProfessionExample",

  // OCR placeholders/examples
  placeholderCityExample = "placeholderCityExample",
  placeholderPostalCodeExample = "placeholderPostalCodeExample",
  placeholderPlaceOfBirthExample = "placeholderPlaceOfBirthExample",
  placeholderDocumentNumberExample = "placeholderDocumentNumberExample",
  placeholderCountryExample = "placeholderCountryExample",
  placeholderNumberOfChildrenExample = "placeholderNumberOfChildrenExample",
  placeholderProfessionExample = "placeholderProfessionExample",
  placeholderActivitySectorExample = "placeholderActivitySectorExample",
  placeholderSalaryExample = "placeholderSalaryExample",

  // Screening status pills (labels & tooltips)
  screeningStatus_ok_label = "screeningStatus_ok_label",
  screeningStatus_avert_label = "screeningStatus_avert_label",
  screeningStatus_alerte_label = "screeningStatus_alerte_label",
  screeningStatus_echec_label = "screeningStatus_echec_label",
  screeningStatus_clear_label = "screeningStatus_clear_label",
  screeningStatus_faible_label = "screeningStatus_faible_label",
  screeningStatus_standard_label = "screeningStatus_standard_label",
  screeningStatus_high_label = "screeningStatus_high_label",
  screeningStatus_unknown_label = "screeningStatus_unknown_label",
  screeningStatus_unknown_tooltip = "screeningStatus_unknown_tooltip",

  screeningStatus_risqueInitial_ok = "screeningStatus_risqueInitial_ok",
  screeningStatus_risqueInitial_avert = "screeningStatus_risqueInitial_avert",
  screeningStatus_risqueInitial_alerte = "screeningStatus_risqueInitial_alerte",

  screeningStatus_coherenceIdentite_ok = "screeningStatus_coherenceIdentite_ok",
  screeningStatus_coherenceIdentite_avert = "screeningStatus_coherenceIdentite_avert",
  screeningStatus_coherenceIdentite_echec = "screeningStatus_coherenceIdentite_echec",

  screeningStatus_ocrQualite_ok = "screeningStatus_ocrQualite_ok",
  screeningStatus_ocrQualite_echec = "screeningStatus_ocrQualite_echec",

  screeningStatus_completude_ok = "screeningStatus_completude_ok",

  screeningStatus_sanctionsPep_clear = "screeningStatus_sanctionsPep_clear",
  screeningStatus_sanctionsPep_faible = "screeningStatus_sanctionsPep_faible",
  screeningStatus_sanctionsPep_standard = "screeningStatus_sanctionsPep_standard",
  screeningStatus_sanctionsPep_high = "screeningStatus_sanctionsPep_high",

  productsAccounts = "productsAccounts",
  productsAccountsDescription = "productsAccountsDescription",
  screeningContext = "screeningContext",
  majorMinor = "majorMinor",
  resident = "resident",
  nonResident = "nonResident",
  pepStatus = "pepStatus",
  clientType = "clientType",
  product = "product",
  productCategory = "productCategory",
  additionalServices = "additionalServices",
  classicCreditCard = "classicCreditCard",
  classicCreditCardDescription = "classicCreditCardDescription",
  smsBanking = "smsBanking",
  smsBankingDescription = "smsBankingDescription",
  internetBanking = "internetBanking",
  internetBankingDescription = "internetBankingDescription",
  checkbook = "checkbook",
  checkbookDescription = "checkbookDescription",

  // Additional Documents Step (Onboarding)
  additionalDocumentsStepTitle = "additionalDocumentsStepTitle",
  requiredShort = "requiredShort",
  optionalShort = "optionalShort",
  validatedShort = "validatedShort",
  pendingShort = "pendingShort",
  idDocumentName = "idDocumentName",
  proofOfResidenceUnder3Months = "proofOfResidenceUnder3Months",
  signedOpeningForm = "signedOpeningForm",
  pepDeclaration = "pepDeclaration",
  savingsObjectiveCertificate = "savingsObjectiveCertificate",

  // Core Banking Search
  coreBanking = "coreBanking",
  searchCoreBanking = "searchCoreBanking",
  searchCoreBankingDescription = "searchCoreBankingDescription",
  accountNumber = "accountNumber",
  searchCoreBankingTip = "searchCoreBankingTip",

  // Empty State Messages
  noCustomersFound = "noCustomersFound",
  tryAdjustingFilters = "tryAdjustingFilters",
  startSearching = "startSearching",

  access_generated_successfully = "access_generated_successfully",
  access_generated_successfully_description = "access_generated_successfully_description",
  access_generated_failed = "access_generated_failed",
  access_generated_failed_description = "access_generated_failed_description",
  access_generating = "access_generating",
  access_generating_description = "access_generating_description",
  regenerate_access = "regenerate_access",
  generate_access = "generate_access",
  revoke_access = "revoke_access",
  revoke_confirm_title = "revoke_confirm_title",
  revoke_confirm_description = "revoke_confirm_description",
  revoke_sensitive_warning = "revoke_sensitive_warning",
  revoke_reason_label = "revoke_reason_label",
  revoke_reason_placeholder = "revoke_reason_placeholder",
  revoke_reason_suspicion_fraud = "revoke_reason_suspicion_fraud",
  revoke_reason_creation_error = "revoke_reason_creation_error",
  revoke_reason_end_relationship = "revoke_reason_end_relationship",
  revoke_reason_customer_request = "revoke_reason_customer_request",
  revoke_reason_internal_control = "revoke_reason_internal_control",
  revoke_reason_other = "revoke_reason_other",
  revoke_reason_custom_placeholder = "revoke_reason_custom_placeholder",
  revoke_reason_min_counter = "revoke_reason_min_counter",
  revoke_confirm_button = "revoke_confirm_button",
  revoke_confirming_button = "revoke_confirming_button",
  access_revoking = "access_revoking",
  access_revoking_description = "access_revoking_description",
  access_revoked_successfully = "access_revoked_successfully",
  access_revoked_successfully_description = "access_revoked_successfully_description",
  access_revoke_failed = "access_revoke_failed",
  access_revoke_failed_description = "access_revoke_failed_description",
  access_revoked_alert_title = "access_revoked_alert_title",
  access_revoked_alert_description = "access_revoked_alert_description",

  missing = "missing",
  uploaded = "uploaded",
  verified = "verified",
  required = "required",
  optional = "optional",
  clickToUpload = "clickToUpload",
  notdocumentToUpload = "notdocumentToUpload",
  notdocumentToUploadDescription = "notdocumentToUploadDescription",

  // KYC
  civilIdentity = "civilIdentity",
  actionRequired = "actionRequired",
  officialIdentifiers = "officialIdentifiers",
  notExpired = "notExpired",
  changeIdentity = "changeIdentity",
  contactDetails = "contactDetails",
  mainMobileNumber = "mainMobileNumber",
  secondaryMobileNumber = "secondaryMobileNumber",
  taxationCompliance = "taxationCompliance",
  declarationPEP = "declarationPEP",
  CountryOfTaxation = "CountryOfTaxation",
  TaxIDNumber = "TaxIDNumber",
  pep = "pep",
  residentStatus = "residentStatus",
  residenceAddress = "residenceAddress",
  changeAddress = "changeAddress",
  reference = "reference",
  balance = "balance",
  money = "money",
  rib = "rib",
  openAt = "openAt",
  downloadRIB = "downloadRIB",
  ribDownloading = "ribDownloading",
  ribDownloaded = "ribDownloaded",
  ribDownloadError = "ribDownloadError",
  miniStatement = "miniStatement",
  viewMiniStatement = "viewMiniStatement",
  debit = "debit",
  movementLabel = "movementLabel",
  movementSense = "movementSense",
  movementAmount = "movementAmount",
  movementBalanceAfter = "movementBalanceAfter",
  noMovements = "noMovements",
  miniStatementLoadError = "miniStatementLoadError",
  customerDocuments = "customerDocuments",
  expiration = "expiration",
  reusable = "reusable",
  RelatedRequest = "RelatedRequest",
  civility = "civility",
  sectorActivity = "sectorActivity",
  comment = "comment",
  contactForSavingCardCredit = "contactForSavingCardCredit",

  // Dashboard Page Not Ready
  dashboardPageNotReady = "dashboardPageNotReady",
  dashboardPageNotReadyDescription = "dashboardPageNotReadyDescription",

  // Commercial Dashboard (P1)
  commercialDashboard = "commercialDashboard",
  volumeOnboardingInities = "volumeOnboardingInities",
  kpiProspectsCrees = "kpiProspectsCrees",
  kpiKycCompletion = "kpiKycCompletion",
  kpiAvgTimeToCollect = "kpiAvgTimeToCollect",
  kpiConversionRate = "kpiConversionRate",
  kpiCeMois = "kpiCeMois",
  kpiRetry = "kpiRetry",
  kpiDataUnavailable = "kpiDataUnavailable",
  kpiOutlierBadge = "kpiOutlierBadge",
  kpiConversionTooltip = "kpiConversionTooltip",
  kpiConversionSubLabel = "kpiConversionSubLabel",
  kpiTipOnboardingVolume = "kpiTipOnboardingVolume",
  kpiTipKycCompletion = "kpiTipKycCompletion",
  kpiTipTimeToCollect = "kpiTipTimeToCollect",
  kpiTipConversion = "kpiTipConversion",
  kpiTipBranchSla = "kpiTipBranchSla",
  kpiTipDocRejection = "kpiTipDocRejection",
  kpiTipRekycBacklog = "kpiTipRekycBacklog",
  kpiTipCommercialVolume = "kpiTipCommercialVolume",
  kpiTipTriage = "kpiTipTriage",
  kpiTipEddDelay = "kpiTipEddDelay",
  kpiTipFalsePositive = "kpiTipFalsePositive",
  kpiTipBacklogAge = "kpiTipBacklogAge",
  kpiTipSodConformity = "kpiTipSodConformity",
  kpiTipFourEyesSla = "kpiTipFourEyesSla",
  kpiTipHighRiskCoverage = "kpiTipHighRiskCoverage",
  kpiTipSodDerogation = "kpiTipSodDerogation",
  kpiTipTriggerLabel = "kpiTipTriggerLabel",
  kpiConvertedSubLabel = "kpiConvertedSubLabel",
  kpiDays = "kpiDays",
  kpiHours = "kpiHours",
  kpiActiveEddCasesSubLabel = "kpiActiveEddCasesSubLabel",
  kpiTrendUp = "kpiTrendUp",
  kpiTrendDown = "kpiTrendDown",

  // Dashboards â€” menu section & persona titles / breadcrumbs
  dashboardsSection = "dashboardsSection",
  dashboardCommercial = "dashboardCommercial",
  dashboardAgence = "dashboardAgence",
  dashboardCompliance = "dashboardCompliance",
  dashboardConformite = "dashboardConformite",
  dashboardCommercialSubtitle = "dashboardCommercialSubtitle",
  dashboardAgenceSubtitle = "dashboardAgenceSubtitle",
  dashboardComplianceSubtitle = "dashboardComplianceSubtitle",
  dashboardConformiteSubtitle = "dashboardConformiteSubtitle",
  agence = "agence",

  // KPI â€” unavailable tile
  kpiComingSoon = "kpiComingSoon",
  kpiComingSoonDescription = "kpiComingSoonDescription",

  // KPI â€” P1 conversion drill-down card
  kpiConversionDrillDownCta = "kpiConversionDrillDownCta",

  // KPI â€” P2 (Agence)
  kpiBranchSla = "kpiBranchSla",
  kpiBranchSlaSubLabel = "kpiBranchSlaSubLabel",
  kpiDocRejection = "kpiDocRejection",
  kpiDocRejectionSubLabel = "kpiDocRejectionSubLabel",
  kpiCommercialVolume = "kpiCommercialVolume",
  kpiCommercialVolumeSubLabel = "kpiCommercialVolumeSubLabel",
  kpiRekycBacklog = "kpiRekycBacklog",

  // KPI â€” P3 (Compliance)
  kpiTriageProductivity = "kpiTriageProductivity",
  kpiTriageSubLabel = "kpiTriageSubLabel",
  kpiEddDelay = "kpiEddDelay",
  kpiFalsePositiveRate = "kpiFalsePositiveRate",
  kpiFalsePositiveSubLabel = "kpiFalsePositiveSubLabel",
  kpiBacklogAge = "kpiBacklogAge",

  // KPI â€” P4 (ConformitÃ©)
  kpiSodConformity = "kpiSodConformity",
  kpiSodConformitySubLabel = "kpiSodConformitySubLabel",
  kpiFourEyesSla = "kpiFourEyesSla",
  kpiHighRiskCoverage = "kpiHighRiskCoverage",
  kpiHighRiskCoverageSubLabel = "kpiHighRiskCoverageSubLabel",
  kpiHighRiskUncoveredPill = "kpiHighRiskUncoveredPill",
  kpiSodDerogation = "kpiSodDerogation",
  kpiSodDerogationSubLabel = "kpiSodDerogationSubLabel",

  // Prospects & Client360 - Common
  all = "all",
  legalPerson = "legalPerson",
  moreCharacters = "moreCharacters",
  start = "start",
  end = "end",
  datePlaceholder = "datePlaceholder",
  invalidAccountNumber = "invalidAccountNumber",
  accountNumberExample = "accountNumberExample",
  pageOf = "pageOf",
  searchAndFilterProspects = "searchAndFilterProspects",
  identityRepository = "identityRepository",
  importCsv = "importCsv",
  newProspectRequest = "newProspectRequest",
  importing = "importing",
  importAction = "importAction",

  // Prospects - Status & Types
  eligible = "eligible",
  toComplete = "toComplete",
  refused = "refused",
  duplicatePending = "duplicatePending",
  web = "web",
  branch = "branch",
  corporate = "corporate",
  clearScreening = "clearScreening",
  possible = "possible",
  matchedSanction = "matchedSanction",
  noneScreening = "noneScreening",

  // Core Banking Columns
  clientCode = "clientCode",
  lastNameColumn = "lastNameColumn",
  genderColumn = "genderColumn",
  nationalityColumn = "nationalityColumn",
  maritalStatusColumn = "maritalStatusColumn",
  postalCodeColumn = "postalCodeColumn",
  phoneColumn = "phoneColumn",
  lastUpdateAbbr = "lastUpdateAbbr",

  Voir = "Voir",
  minor = "minor",
  major = "major",
  sinceAt = "sinceAt",
  viewer = "viewer",

  digits = "digits",
  maxPhoneCharactersMessage = "maxPhoneCharactersMessage",
  minPhoneCharactersMessage = "minPhoneCharactersMessage",

  assignments = "assignments",
  attributeRole = "attributeRole",
  noRolesFound = "noRolesFound",
  rolesPerPage = "rolesPerPage",

  // Administration
  featureComingSoon = "featureComingSoon",
  rolesAndRights = "rolesAndRights",
  rolesAndRightsDescription = "rolesAndRightsDescription",
  newUser = "newUser",
  newUserDialogTitle = "newUserDialogTitle",
  newUserDialogDescription = "newUserDialogDescription",
  editImportDescription = "editImportDescription",
  phone1 = "phone1",
  email1 = "email1",
  phone2 = "phone2",
  email2 = "email2",
  chooseOrEnterEmail = "chooseOrEnterEmail",
  chooseOrEnterPhone = "chooseOrEnterPhone",
  kycInformation = "kycInformation",

  // fiche-client360 specific
  identityDocument = "identityDocument",
  phoneNumbers = "phoneNumbers",
  primaryPhone = "primaryPhone",
  secondaryPhone = "secondaryPhone",
  fax = "fax",
  primaryEmail = "primaryEmail",
  secondaryEmail = "secondaryEmail",
  emailAddresses = "emailAddresses",
  noPhoneProvided = "noPhoneProvided",
  noEmailProvided = "noEmailProvided",
  notDetermined = "notDetermined",
  recentScreeningReports = "recentScreeningReports",
  accountsOverview = "accountsOverview",
  viewAllAccounts = "viewAllAccounts",
  complianceTitle = "complianceTitle",
  nextReKYC = "nextReKYC",
  consentsSummary = "consentsSummary",
  openConsentCenter = "openConsentCenter",
  noResult = "noResult",
  loadingError = "loadingError",
  title = "title",
  dataset = "dataset",
  statusRating = "statusRating",
  profileNotFound = "profileNotFound",
  profileNotFoundDescription = "profileNotFoundDescription",
  notVerified = "notVerified",
  otpVerificationRequired = "otpVerificationRequired",
  verificationCodeSent = "verificationCodeSent",
  didNotReceiveCode = "didNotReceiveCode",
  resendIn = "resendIn",
  resendCode = "resendCode",
  sendCode = "sendCode",
  enterMinDigitsToReceiveCode = "enterMinDigitsToReceiveCode",
  enterValidEmailToReceiveCode = "enterValidEmailToReceiveCode",
  verify = "verify",

  // Client360 - access regeneration tooltip
  verify_contacts_before_regenerate_access = "verify_contacts_before_regenerate_access",

  // Onboarding â€“ validation errors
  onboarding_identityDocRequired = "onboarding_identityDocRequired",
  onboarding_addressProofRequired = "onboarding_addressProofRequired",
  onboarding_idInvalidUploadNew = "onboarding_idInvalidUploadNew",
  onboarding_applyOcrAndFillRequired = "onboarding_applyOcrAndFillRequired",
  onboarding_productsAccountsRequired = "onboarding_productsAccountsRequired",
  onboarding_uploadRequiredDocsFirst = "onboarding_uploadRequiredDocsFirst",

  // Onboarding â€“ toasts & submit
  onboarding_resubmit = "onboarding_resubmit",
  onboarding_submittedSuccess = "onboarding_submittedSuccess",
  onboarding_submitError = "onboarding_submitError",
  onboarding_businessKeyMissing = "onboarding_businessKeyMissing",
  onboarding_submitFailed = "onboarding_submitFailed",
  onboarding_productsSaveSuccess = "onboarding_productsSaveSuccess",
  onboarding_productsSaveSuccessDesc = "onboarding_productsSaveSuccessDesc",
  onboarding_productsSaveFailed = "onboarding_productsSaveFailed",
  onboarding_productsSaveFailedDesc = "onboarding_productsSaveFailedDesc",
  onboarding_productsSaving = "onboarding_productsSaving",
  onboarding_productsSavingDesc = "onboarding_productsSavingDesc",
  onboarding_productsFetchFailed = "onboarding_productsFetchFailed",
  onboarding_productsFetchError = "onboarding_productsFetchError",
  onboarding_identitySavedSuccess = "onboarding_identitySavedSuccess",
  onboarding_identitySaveFailed = "onboarding_identitySaveFailed",
  onboarding_metadataSavedSuccess = "onboarding_metadataSavedSuccess",
  onboarding_metadataSaveFailed = "onboarding_metadataSaveFailed",
  onboarding_metadataSaveError = "onboarding_metadataSaveError",

  // UserProfile
  roles = "roles",
  lastConnection = "lastConnection",
  profileCreatedAt = "profileCreatedAt",
  permission = "permission",
  recentActivities = "recentActivities",
  action = "action",
  inactivate = "inactivate",
  activate = "activate",

  // Onboarding - Document Card
  removeFile = "removeFile",
  removeFileDescription = "removeFileDescription",
  confirm = "confirm",
  deleting = "deleting",

  // Roles Matrix
  preCheckSoD = "preCheckSoD",
  roleName = "roleName",
  roleNamePlaceholder = "roleNamePlaceholder",
  purpose = "purpose",
  purposePlaceholder = "purposePlaceholder",
  scope = "scope",
  permissionSelected = "permissionSelected",
  selected = "selected",
  loadingPermissions = "loadingPermissions",
  domain = "domain",
  description = "description",
  grant = "grant",
  preCheckSoDDescription = "preCheckSoDDescription",
  noConflicts = "noConflicts",
  conflict = "conflict",
  restart = "restart",
  noDetailsShown = "noDetailsShown",
  usersList = "usersList",
  addNewUser = "addNewUser",
  addNewUserDescription = "addNewUserDescription",
  createUser = "createUser",
  searchUser = "searchUser",
  confirmCreation = "confirmCreation",
  userEmail = "userEmail",
  searching = "searching",
  userFound = "userFound",
  selectedUser = "selectedUser",
  rbacId = "rbacId",
  usernameLettersNumbers = "usernameLettersNumbers",
  userWillBeCreatedInactive = "userWillBeCreatedInactive",
  withoutRoleAssigned = "withoutRoleAssigned",
  activeSOD = "activeSOD",
  notAvailable = "notAvailable",
  /** Abbreviation for missing value (e.g. contact fields). */
  na = "na",
  sodConflicts = "sodConflicts",
  sodConflictsDescription = "sodConflictsDescription",
  highCriticality = "highCriticality",
  highCriticalityDescription = "highCriticalityDescription",
  attribute = "attribute",
  justification = "justification",
  justificationRequired = "justificationRequired",
  selectedUsers = "selectedUsers",
  noPermissions = "noPermissions",
  showMore = "showMore",
  showLess = "showLess",
  owner = "owner",
  numberOfAssignments = "numberOfAssignments",
  userFile = "userFile",
  userFileDescription = "userFileDescription",
  street = "street",
  bankInformation = "bankInformation",
  agencyCode = "agencyCode",
  employmentType = "employmentType",
  company = "company",
  otherInformation = "otherInformation",
  profilRating = "profilRating",
  customerDetailsFromCoreBanking = "customerDetailsFromCoreBanking",
  importStep = "importStep",
  userMatricule = "userMatricule",
  function = "function",
  departement = "departement",
  assigningRoleToUsers = "assigningRoleToUsers",
  roleAssignedSuccessfully = "roleAssignedSuccessfully",
  roleAssignedSuccessfullyDescription = "roleAssignedSuccessfullyDescription",
  revokeRole = "revokeRole",
  revokeRoleConfirmTitle = "revokeRoleConfirmTitle",
  revokeRoleConfirmDescription = "revokeRoleConfirmDescription",
  revokingRole = "revokingRole",
  roleRevokedSuccessfully = "roleRevokedSuccessfully",
  roleRevokedSuccessfullyDescription = "roleRevokedSuccessfullyDescription",

  // Fiche client 360 â€” onglet statut civil
  civilStatusAndCapacity = "civilStatusAndCapacity",
  changeCivilStatus = "changeCivilStatus",
  addLegalRepresentative = "addLegalRepresentative",
  civilStatusLabel = "civilStatusLabel",
  legalCapacity = "legalCapacity",
  legalReferent = "legalReferent",
  fatherFirstNames = "fatherFirstNames",
  motherFirstNames = "motherFirstNames",
  deathDate = "deathDate",
  socioProfessionalSituation = "socioProfessionalSituation",
  updateIncomeEmployer = "updateIncomeEmployer",
  professionCountry = "professionCountry",
  clientQuality = "clientQuality",
  monthlyRemuneration = "monthlyRemuneration",
  bceaoSocioProNote = "bceaoSocioProNote",
  matrimonialAndFamily = "matrimonialAndFamily",
  changeFamilySituation = "changeFamilySituation",
  matrimonialRegime = "matrimonialRegime",
  marriageContract = "marriageContract",
  spouseLastName = "spouseLastName",
  spouseFirstName = "spouseFirstName",
  belongingAndBanking = "belongingAndBanking",
  relationOtherInstitutions = "relationOtherInstitutions",
  bankPersonnel = "bankPersonnel",

  patrimoineRealEstateAssets = "patrimoineRealEstateAssets",
  patrimoineRealEstateAssetsHint = "patrimoineRealEstateAssetsHint",
  patrimoineHowManyProperties = "patrimoineHowManyProperties",
  patrimoineAssetsInsured = "patrimoineAssetsInsured",
  patrimoineEstimatedValue = "patrimoineEstimatedValue",
  patrimoineOtherBankAccounts = "patrimoineOtherBankAccounts",
  patrimoineOtherBankAccountsHint = "patrimoineOtherBankAccountsHint",
  patrimoineTotalApproximateValue = "patrimoineTotalApproximateValue",
  patrimoineValuableObjects = "patrimoineValuableObjects",
  patrimoineValuableObjectsHint = "patrimoineValuableObjectsHint",
  patrimoineEdit = "patrimoineEdit",

  roleBlocked = "roleBlocked",
  roleBlockedDescription = "roleBlockedDescription",

  commercial = "commercial",
  conformite = "conformite",
  thisMonth = "thisMonth",
  previousMonth = "previousMonth",

  // Risk Entity Referential (US-6.5a)
  riskEntityReferential = "riskEntityReferential",
  riskEntityReferentialDescription = "riskEntityReferentialDescription",
  riskEntityTabEntities = "riskEntityTabEntities",
  riskEntityTabWeighting = "riskEntityTabWeighting",
  riskEntityWeightingDescription = "riskEntityWeightingDescription",
  riskEntityWeightingSectionTitle = "riskEntityWeightingSectionTitle",
  riskEntityWeightingSectionSubtitle = "riskEntityWeightingSectionSubtitle",
  riskEntityWeightingCardTitle = "riskEntityWeightingCardTitle",
  riskEntityWeightingTotalLabel = "riskEntityWeightingTotalLabel",
  riskEntityWeightingLseg = "riskEntityWeightingLseg",
  riskEntityWeightingVneurone = "riskEntityWeightingVneurone",
  riskEntityWeightingPercentHint = "riskEntityWeightingPercentHint",
  riskEntityWeightingSubmitLoading = "riskEntityWeightingSubmitLoading",
  riskEntityWeightingValidate = "riskEntityWeightingValidate",
  riskEntityWeightingSumMustBe100 = "riskEntityWeightingSumMustBe100",
  riskEntityWeightingInvalidPercent = "riskEntityWeightingInvalidPercent",
  riskEntityWeightingPercentRange = "riskEntityWeightingPercentRange",
  riskEntityWeightingSubmittedSuccess = "riskEntityWeightingSubmittedSuccess",
  riskEntityWeightingConfigLoading = "riskEntityWeightingConfigLoading",
  riskEntityWeightingReason = "riskEntityWeightingReason",
  riskEntityWeightingReasonPlaceholder = "riskEntityWeightingReasonPlaceholder",
  riskEntityWeightingReasonRequired = "riskEntityWeightingReasonRequired",
  riskEntityWeightingReasonMinLength = "riskEntityWeightingReasonMinLength",
  riskEntityWeightingHistorySheetTitle = "riskEntityWeightingHistorySheetTitle",
  riskEntityWeightingHistorySheetSubtitle = "riskEntityWeightingHistorySheetSubtitle",
  riskEntityWeightingHistoryLoading = "riskEntityWeightingHistoryLoading",
  riskEntityWeightingHistoryEmpty = "riskEntityWeightingHistoryEmpty",
  riskEntityWeightingHistoryColDate = "riskEntityWeightingHistoryColDate",
  riskEntityWeightingHistoryColAuthor = "riskEntityWeightingHistoryColAuthor",
  riskEntityWeightingHistoryColBefore = "riskEntityWeightingHistoryColBefore",
  riskEntityWeightingHistoryColAfter = "riskEntityWeightingHistoryColAfter",
  riskEntityWeightingHistoryColReason = "riskEntityWeightingHistoryColReason",
  entityType_OBJET_COMPTE = "entityType_OBJET_COMPTE",
  entityType_SOURCE_REVENU = "entityType_SOURCE_REVENU",
  entityType_PAYS = "entityType_PAYS",
  entityType_PROFESSION = "entityType_PROFESSION",
  entityType_ACTIVITE = "entityType_ACTIVITE",
  entityType_PRODUIT = "entityType_PRODUIT",
  entityType_CANAL = "entityType_CANAL",
  entityType_ANNEE_CONSTITUTION = "entityType_ANNEE_CONSTITUTION",
  riskLevel_RE = "riskLevel_RE",
  riskLevel_RM = "riskLevel_RM",
  riskLevel_RF = "riskLevel_RF",
  riskEntityCode = "riskEntityCode",
  riskEntityLibelle = "riskEntityLibelle",
  riskEntityLevel = "riskEntityLevel",
  riskEntityActive = "riskEntityActive",
  riskEntityLastModified = "riskEntityLastModified",
  riskEntityAddCode = "riskEntityAddCode",
  riskEntityEditLevel = "riskEntityEditLevel",
  riskEntityDeactivate = "riskEntityDeactivate",
  riskEntityHistory = "riskEntityHistory",
  riskEntityNewCode = "riskEntityNewCode",
  riskEntityEditCode = "riskEntityEditCode",
  riskEntityDeactivateTitle = "riskEntityDeactivateTitle",
  riskEntityDeactivateDescription = "riskEntityDeactivateDescription",
  riskEntityRollbackTitle = "riskEntityRollbackTitle",
  riskEntityRollbackDescription = "riskEntityRollbackDescription",
  riskEntityRollbackConfirm = "riskEntityRollbackConfirm",
  riskEntityRestoreVersion = "riskEntityRestoreVersion",
  riskEntityChangeReason = "riskEntityChangeReason",
  riskEntityChangeReasonPlaceholder = "riskEntityChangeReasonPlaceholder",
  riskEntityNoCodesFound = "riskEntityNoCodesFound",
  riskEntityFilterByLevel = "riskEntityFilterByLevel",
  riskEntityAllLevels = "riskEntityAllLevels",
  riskEntitySearchPlaceholder = "riskEntitySearchPlaceholder",
  riskEntityStatusActive = "riskEntityStatusActive",
  riskEntityStatusInactive = "riskEntityStatusInactive",
  riskEntityHistoryAction_ADD = "riskEntityHistoryAction_ADD",
  riskEntityHistoryAction_MODIFY = "riskEntityHistoryAction_MODIFY",
  riskEntityHistoryAction_DEACTIVATE = "riskEntityHistoryAction_DEACTIVATE",
  riskEntityHistoryAction_ROLLBACK = "riskEntityHistoryAction_ROLLBACK",
  riskEntityCreatedSuccess = "riskEntityCreatedSuccess",
  riskEntityUpdatedSuccess = "riskEntityUpdatedSuccess",
  riskEntityDeactivatedSuccess = "riskEntityDeactivatedSuccess",
  riskEntityRolledBackSuccess = "riskEntityRolledBackSuccess",
  riskEntityOperationFailed = "riskEntityOperationFailed",
  riskEntityCodes = "riskEntityCodes",
  riskEntityModifyConfirmTitle = "riskEntityModifyConfirmTitle",
  riskEntityNoHistory = "riskEntityNoHistory",

  // Risk Entity Referential â€” CSV Import (US-6.5b)
  riskEntityImportCsv = "riskEntityImportCsv",
  riskEntityImportModalTitle = "riskEntityImportModalTitle",
  riskEntityImportDropzone = "riskEntityImportDropzone",
  riskEntityImportDropzoneHint = "riskEntityImportDropzoneHint",
  riskEntityImportSelectFile = "riskEntityImportSelectFile",
  riskEntityImportPreviewTitle = "riskEntityImportPreviewTitle",
  riskEntityImportAdded = "riskEntityImportAdded",
  riskEntityImportModified = "riskEntityImportModified",
  riskEntityImportUnchanged = "riskEntityImportUnchanged",
  riskEntityImportInvalid = "riskEntityImportInvalid",
  riskEntityImportConfirmBtn = "riskEntityImportConfirmBtn",
  riskEntityImportSuccess = "riskEntityImportSuccess",
  riskEntityImportShowUnchanged = "riskEntityImportShowUnchanged",
  riskEntityImportHideUnchanged = "riskEntityImportHideUnchanged",
  riskEntityImportErrorReason = "riskEntityImportErrorReason",
  riskEntityImportEmpty = "riskEntityImportEmpty",
  riskEntityImportFileTypeError = "riskEntityImportFileTypeError",
  riskEntityImportColumnCode = "riskEntityImportColumnCode",
  riskEntityImportColumnLabel = "riskEntityImportColumnLabel",
  riskEntityImportColumnOldLevel = "riskEntityImportColumnOldLevel",
  riskEntityImportColumnNewLevel = "riskEntityImportColumnNewLevel",
  riskEntityImportColumnStatus = "riskEntityImportColumnStatus",
  riskEntityImportChooseAnother = "riskEntityImportChooseAnother",
  riskEntityImportConfirmCloseTitle = "riskEntityImportConfirmCloseTitle",
  riskEntityImportConfirmCloseDescription = "riskEntityImportConfirmCloseDescription",

  // Risques ConformitÃ© â€” menu
  risquesConformite = "risquesConformite",
  fileDeRevueL1 = "fileDeRevueL1",
  validation4Yeux = "validation4Yeux",

  // EDD 4-yeux module
  eddTitle = "eddTitle",
  eddEmpty = "eddEmpty",
  eddColBusinessKey = "eddColBusinessKey",
  eddColCustomer = "eddColCustomer",
  eddColTrigger = "eddColTrigger",
  eddColStatus = "eddColStatus",
  eddColAnalyst = "eddColAnalyst",
  eddColCreatedAt = "eddColCreatedAt",
  eddFilterAll = "eddFilterAll",
  eddFilterAssignedToMe = "eddFilterAssignedToMe",
  eddStatus_OPEN = "eddStatus_OPEN",
  eddStatus_IN_PROGRESS = "eddStatus_IN_PROGRESS",
  eddStatus_PENDING_L1 = "eddStatus_PENDING_L1",
  eddStatus_PENDING_L2 = "eddStatus_PENDING_L2",
  eddStatus_APPROVED = "eddStatus_APPROVED",
  eddStatus_REJECTED = "eddStatus_REJECTED",
  eddStatus_SUSPENDED = "eddStatus_SUSPENDED",
  eddTrigger_PEP = "eddTrigger_PEP",
  eddTrigger_PEP_SANCTIONED = "eddTrigger_PEP_SANCTIONED",
  eddTrigger_HIGH_RISK = "eddTrigger_HIGH_RISK",
  eddTrigger_MANUAL = "eddTrigger_MANUAL",
  eddTrigger_ESCALATION_L1 = "eddTrigger_ESCALATION_L1",
  eddTrigger_RE_KYC = "eddTrigger_RE_KYC",
  eddTrigger_TRANSACTION_ALERT = "eddTrigger_TRANSACTION_ALERT",
  eddTrigger_UNKNOWN = "eddTrigger_UNKNOWN",
  eddDocType_IDENTITY = "eddDocType_IDENTITY",
  eddDocType_SOURCE_OF_FUNDS = "eddDocType_SOURCE_OF_FUNDS",
  eddDocType_BUSINESS_ACTIVITY = "eddDocType_BUSINESS_ACTIVITY",
  eddDocType_BENEFICIAL_OWNER = "eddDocType_BENEFICIAL_OWNER",
  eddDocType_OTHER = "eddDocType_OTHER",
  eddDocumentsTitle = "eddDocumentsTitle",
  eddNoDocuments = "eddNoDocuments",
  eddDownload = "eddDownload",
  eddPreview = "eddPreview",
  eddUploadTitle = "eddUploadTitle",
  eddUploadType = "eddUploadType",
  eddUploadFile = "eddUploadFile",
  eddUploadComment = "eddUploadComment",
  eddUploadSubmit = "eddUploadSubmit",
  eddHistoryTitle = "eddHistoryTitle",
  eddActionAddDocument = "eddActionAddDocument",
  eddActionSubmitL1 = "eddActionSubmitL1",
  eddActionSubmitL1Hint = "eddActionSubmitL1Hint",
  eddActionAssign = "eddActionAssign",
  eddActionSuspend = "eddActionSuspend",
  eddActionResume = "eddActionResume",
  eddActionApproveL1 = "eddActionApproveL1",
  eddActionApproveL2 = "eddActionApproveL2",
  eddActionApproveL2FourEyesHint = "eddActionApproveL2FourEyesHint",
  eddActionReject = "eddActionReject",
  eddRejectReason = "eddRejectReason",
  eddSuspendReason = "eddSuspendReason",
  eddMfaTitle = "eddMfaTitle",
  eddMfaSentTo = "eddMfaSentTo",
  eddMfaExpiresIn = "eddMfaExpiresIn",
  eddMfaSendError = "eddMfaSendError",
  eddMfaCodeLabel = "eddMfaCodeLabel",
  eddMfaResend = "eddMfaResend",
  eddMfaValidate = "eddMfaValidate",
  eddDecisionNotes = "eddDecisionNotes",
  eddApproveL2Title = "eddApproveL2Title",
  eddApproveL2RiskAssessment = "eddApproveL2RiskAssessment",
  eddApproveL2Conclusion = "eddApproveL2Conclusion",
  eddRisk_MAINTAINED = "eddRisk_MAINTAINED",
  eddRisk_UPGRADED = "eddRisk_UPGRADED",
  eddRisk_DOWNGRADED = "eddRisk_DOWNGRADED",

  // L1 Review page (US 6.3)
  l1ReviewTitle = "l1ReviewTitle",
  l1ReviewBusinessKey = "l1ReviewBusinessKey",
  l1ReviewCustomerName = "l1ReviewCustomerName",
  l1ReviewAssignedTo = "l1ReviewAssignedTo",
  l1ReviewUnassigned = "l1ReviewUnassigned",
  l1ReviewRisk = "l1ReviewRisk",
  l1ReviewTabPending = "l1ReviewTabPending",
  l1ReviewTabEscalated = "l1ReviewTabEscalated",
  l1ReviewTabAuthorized = "l1ReviewTabAuthorized",
  l1ReviewTabRejected = "l1ReviewTabRejected",
  l1ReviewTabSlaBreached = "l1ReviewTabSlaBreached",
  l1ReviewDetailTitle = "l1ReviewDetailTitle",
  l1ReviewDetailNotFound = "l1ReviewDetailNotFound",
  l1ReviewTriggerReason = "l1ReviewTriggerReason",
  l1ReviewTrackAScore = "l1ReviewTrackAScore",
  l1ReviewTrackBScore = "l1ReviewTrackBScore",
  l1ReviewSlaDeadline = "l1ReviewSlaDeadline",
  l1ReviewSlaExpired = "l1ReviewSlaExpired",
  l1ReviewAuthorize = "l1ReviewAuthorize",
  l1ReviewSuspend = "l1ReviewSuspend",
  l1ReviewReject = "l1ReviewReject",
  l1ReviewAssign = "l1ReviewAssign",
  l1ReviewHeldBy = "l1ReviewHeldBy",
  l1ReviewAssignHint = "l1ReviewAssignHint",
  l1ReviewQualifyFirstHint = "l1ReviewQualifyFirstHint",
  l1ReviewEscalate = "l1ReviewEscalate",
  l1ReviewSuspensionReason = "l1ReviewSuspensionReason",
  l1ReviewSuspensionReasonPlaceholder = "l1ReviewSuspensionReasonPlaceholder",
  l1ReviewAuthorizeSuccess = "l1ReviewAuthorizeSuccess",
  l1ReviewSuspendSuccess = "l1ReviewSuspendSuccess",
  l1ReviewEscalateSuccess = "l1ReviewEscalateSuccess",
  l1ReviewActionFailed = "l1ReviewActionFailed",
  l1ReviewEmpty = "l1ReviewEmpty",
  l1ReviewLoading = "l1ReviewLoading",
  l1ReviewLoadingError = "l1ReviewLoadingError",

  // P4 Validation page (US 4.5)
  p4ValidationTitle = "p4ValidationTitle",
  p4ValidationBusinessKey = "p4ValidationBusinessKey",
  p4ValidationOldClass = "p4ValidationOldClass",
  p4ValidationNewClass = "p4ValidationNewClass",
  p4ValidationScoreDelta = "p4ValidationScoreDelta",
  p4ValidationTrigger = "p4ValidationTrigger",
  p4ValidationSlaDeadline = "p4ValidationSlaDeadline",
  p4ValidationSlaExpired = "p4ValidationSlaExpired",
  p4ValidationFlaggedDirectionRisques = "p4ValidationFlaggedDirectionRisques",
  p4ValidationApprove = "p4ValidationApprove",
  p4ValidationReject = "p4ValidationReject",
  p4ValidationJustification = "p4ValidationJustification",
  p4ValidationJustificationPlaceholder = "p4ValidationJustificationPlaceholder",
  p4ValidationNotes = "p4ValidationNotes",
  p4ValidationNotesPlaceholder = "p4ValidationNotesPlaceholder",
  p4ValidationApproveSuccess = "p4ValidationApproveSuccess",
  p4ValidationRejectSuccess = "p4ValidationRejectSuccess",
  p4ValidationActionFailed = "p4ValidationActionFailed",
  p4ValidationEmpty = "p4ValidationEmpty",
  p4ValidationLoading = "p4ValidationLoading",
  p4ValidationLoadingError = "p4ValidationLoadingError",
  p4ValidationPendingCount = "p4ValidationPendingCount",
  p4ValidationForbidden = "p4ValidationForbidden",
  p4ValidationSelfReviewForbidden = "p4ValidationSelfReviewForbidden",
  p4ValidationAlreadyDecided = "p4ValidationAlreadyDecided",
  p4ValidationEmptyApproved = "p4ValidationEmptyApproved",
  p4ValidationEmptyRejected = "p4ValidationEmptyRejected",
  // Filtre par statut + descriptions mÃ©tier au-dessus de la liste
  p4StatusPending = "p4StatusPending",
  p4StatusApproved = "p4StatusApproved",
  p4StatusRejected = "p4StatusRejected",
  p4StatusDescPending = "p4StatusDescPending",
  p4StatusDescApproved = "p4StatusDescApproved",
  p4StatusDescRejected = "p4StatusDescRejected",

  // Compliance triage â€” shared header, SLA countdown, queue summary, toolbar
  l1ReviewSubtitle = "l1ReviewSubtitle",
  p4ValidationSubtitle = "p4ValidationSubtitle",
  eddSubtitle = "eddSubtitle",
  slaDueIn = "slaDueIn",
  slaOverdueSince = "slaOverdueSince",
  queueTotalPending = "queueTotalPending",
  queueDueSoon = "queueDueSoon",
  queueBreached = "queueBreached",
  queueFlaggedDR = "queueFlaggedDR",
  eddQueueOpen = "eddQueueOpen",
  eddQueuePendingL1 = "eddQueuePendingL1",
  eddQueuePendingL2 = "eddQueuePendingL2",
  eddRowClickHint = "eddRowClickHint",
  eddOpenCaseAria = "eddOpenCaseAria",
  eddDetailBack = "eddDetailBack",
  eddDetailCaseInfoTitle = "eddDetailCaseInfoTitle",
  eddDetailSubmittedAt = "eddDetailSubmittedAt",
  eddDetailL1ApprovedBy = "eddDetailL1ApprovedBy",
  eddDetailL2ApprovedBy = "eddDetailL2ApprovedBy",
  eddDetailSlaDeadline = "eddDetailSlaDeadline",
  eddDetailNotFound = "eddDetailNotFound",
  eddCustomerDetailsTitle = "eddCustomerDetailsTitle",
  eddCustomerLoadError = "eddCustomerLoadError",
  eddCustomerDocumentsTitle = "eddCustomerDocumentsTitle",
  eddCustomerNoDocuments = "eddCustomerNoDocuments",
  eddCustomerDocColType = "eddCustomerDocColType",
  eddCustomerDocColName = "eddCustomerDocColName",
  eddCustomerDocColExpiration = "eddCustomerDocColExpiration",
  eddCustomerDocView = "eddCustomerDocView",
  complianceSearchBusinessKey = "complianceSearchBusinessKey",
  complianceFilterTrigger = "complianceFilterTrigger",
  complianceFlaggedOnly = "complianceFlaggedOnly",
  p4ValidationRiskChange = "p4ValidationRiskChange",
  l1AuthorizeConfirmTitle = "l1AuthorizeConfirmTitle",
  l1AuthorizeConfirmBody = "l1AuthorizeConfirmBody",
  l1EscalateConfirmTitle = "l1EscalateConfirmTitle",
  l1EscalateConfirmBody = "l1EscalateConfirmBody",

  cvTrackA = "cvTrackA",
  cvTrackB = "cvTrackB",
  cvFinalDecision = "cvFinalDecision",
  cvWeights = "cvWeights",
  cvDecidedBy = "cvDecidedBy",
  cvScoringWeights = "cvScoringWeights",
  cvCanCreate = "cvCanCreate",
  cvCannotCreate = "cvCannotCreate",
  cvVerdictHold = "cvVerdictHold",
  cvVerdictUnknown = "cvVerdictUnknown",
  cvHoldPending = "cvHoldPending",
  cvBlockingReason = "cvBlockingReason",
  cvVNeuroneMode = "cvVNeuroneMode",
  cvComputedAt = "cvComputedAt",
  cvVerdictClean = "cvVerdictClean",
  cvVerdictWait = "cvVerdictWait",
  cvVerdictFlagged = "cvVerdictFlagged",
  cvVerdictBlocked = "cvVerdictBlocked",
  cvVerdictManualReview = "cvVerdictManualReview",
  cvPendingOver48h = "cvPendingOver48h",
  cvScreeningDetails = "cvScreeningDetails",
  cvLoadError = "cvLoadError",

  // KYC â€” additional information (client 360)
  additionalInformationKYC = "additionalInformationKYC",
  additionalInformationKYCDescription = "additionalInformationKYCDescription",
  financialSituationSection = "financialSituationSection",
  pepStatusSection = "pepStatusSection",
  effectiveBeneficiarySection = "effectiveBeneficiarySection",
  wealthSituation = "wealthSituation",
  sourceOfFunds = "sourceOfFunds",
  bankRelationPurpose = "bankRelationPurpose",
  taxResidenceCountry = "taxResidenceCountry",
  pepFunctionExercised = "pepFunctionExercised",
  effectiveBeneficiary = "effectiveBeneficiary",
  effectiveBeneficiaryIdentity = "effectiveBeneficiaryIdentity",
  placeholderWealthSituation = "placeholderWealthSituation",
  placeholderSourceOfFunds = "placeholderSourceOfFunds",
  placeholderBankRelationPurpose = "placeholderBankRelationPurpose",
  placeholderTaxResidenceCountry = "placeholderTaxResidenceCountry",
  placeholderPepFunction = "placeholderPepFunction",
  placeholderEffectiveBeneficiaryIdentity = "placeholderEffectiveBeneficiaryIdentity",
  immatriculationsSectionTitle = "immatriculationsSectionTitle",
  taxIdentifiersSectionTitle = "taxIdentifiersSectionTitle",
  addImmatriculation = "addImmatriculation",
  addTaxIdentifier = "addTaxIdentifier",
  removeImmatriculation = "removeImmatriculation",
  removeTaxIdentifier = "removeTaxIdentifier",
  registryType = "registryType",
  registryTypeRCCM = "registryTypeRCCM",
  registryTypeOther = "registryTypeOther",
  immatriculationNumber = "immatriculationNumber",
  immatriculationDate = "immatriculationDate",
  immatriculationStatus = "immatriculationStatus",
  statusVerified = "statusVerified",
  statusNotVerified = "statusNotVerified",
  statusInProgress = "statusInProgress",
  statusToReverify = "statusToReverify",
  registrationSyncedReadOnly = "registrationSyncedReadOnly",
  justificationAlternative = "justificationAlternative",
  pendingComplianceValidation = "pendingComplianceValidation",
  taxIdentifierType = "taxIdentifierType",
  taxIdentifierTypeIFU = "taxIdentifierTypeIFU",
  taxIdentifierTypeNIF = "taxIdentifierTypeNIF",
  taxIdentifierTypeNINEA = "taxIdentifierTypeNINEA",
  taxIdentifierTypeOther = "taxIdentifierTypeOther",
  taxIdentifierValue = "taxIdentifierValue",
  immatriculationGateBlocked = "immatriculationGateBlocked",
  registrationVerificationDecide = "registrationVerificationDecide",
  registrationVerificationTitle = "registrationVerificationTitle",
  registrationVerificationTargetStatus = "registrationVerificationTargetStatus",
  registrationVerificationSource = "registrationVerificationSource",
  registrationVerificationJustification = "registrationVerificationJustification",
  registrationVerificationProofFile = "registrationVerificationProofFile",
  registrationVerificationSubmit = "registrationVerificationSubmit",
  registrationVerificationCancel = "registrationVerificationCancel",
  registrationVerificationProofRequired = "registrationVerificationProofRequired",
  registrationVerificationPendingSync = "registrationVerificationPendingSync",
  registrationVerificationError = "registrationVerificationError",

  // Confirmation d'un changement d'identitÃ© dÃ©tectÃ© lors d'une nouvelle ocÃ©risation
  ocrChangeCriticalTitle = "ocrChangeCriticalTitle",
  ocrChangeCriticalIntro = "ocrChangeCriticalIntro",
  ocrChangeCriticalConsequence = "ocrChangeCriticalConsequence",
  ocrChangeCriticalAttestation = "ocrChangeCriticalAttestation",
  ocrChangeReasonLabel = "ocrChangeReasonLabel",
  ocrChangeReasonPlaceholder = "ocrChangeReasonPlaceholder",
  ocrChangeSensitiveTitle = "ocrChangeSensitiveTitle",
  ocrChangeSensitiveIntro = "ocrChangeSensitiveIntro",
  ocrChangeNewCaptureTitle = "ocrChangeNewCaptureTitle",
  ocrChangeNewCaptureIntro = "ocrChangeNewCaptureIntro",
  ocrChangeDetectedValue = "ocrChangeDetectedValue",
  ocrChangeAlsoChanged = "ocrChangeAlsoChanged",
  ocrChangeLegalAgeWarning = "ocrChangeLegalAgeWarning",
  ocrChangeIdPaperWarning = "ocrChangeIdPaperWarning",
  ocrChangeBefore = "ocrChangeBefore",
  ocrChangeAfter = "ocrChangeAfter",
  ocrChangeCancel = "ocrChangeCancel",
  ocrChangeConfirm = "ocrChangeConfirm",
  ocrChangeFieldLastName = "ocrChangeFieldLastName",
  ocrChangeFieldFirstName = "ocrChangeFieldFirstName",
  ocrChangeFieldBirthDate = "ocrChangeFieldBirthDate",
  ocrChangeFieldIdPaperNumber = "ocrChangeFieldIdPaperNumber",
  ocrChangeFieldNni = "ocrChangeFieldNni",
  ocrChangeFieldNationality = "ocrChangeFieldNationality",
  ocrChangeFieldBirthPlace = "ocrChangeFieldBirthPlace",
  ocrChangeFieldGender = "ocrChangeFieldGender",
  ocrChangeFieldDeliveryDate = "ocrChangeFieldDeliveryDate",
  ocrChangeFieldValidityDate = "ocrChangeFieldValidityDate",

  // Rattachement de l'agent connecte, tel que l'annuaire du personnel le connait
  staffDirectoryTitle = "staffDirectoryTitle",
  staffDirectoryBranch = "staffDirectoryBranch",
  staffDirectoryEmail = "staffDirectoryEmail",
  staffDirectoryNoBranch = "staffDirectoryNoBranch",
  staffDirectoryAmbiguousBranch = "staffDirectoryAmbiguousBranch",
  staffDirectoryBranchCount = "staffDirectoryBranchCount",
  accountOpeningRecapScoreDecision = "accountOpeningRecapScoreDecision",
  accountOpeningRecapSignatoriesTitle = "accountOpeningRecapSignatoriesTitle",
  addMandate = "addMandate",
  businessKey = "businessKey",
  decisionOutcomeRejected = "decisionOutcomeRejected",
  declarantRole = "declarantRole",
  documentChecklistIndeterminateMessage = "documentChecklistIndeterminateMessage",
  documentIndeterminateBadge = "documentIndeterminateBadge",
  documentStatusAttendue = "documentStatusAttendue",
  documentStatusRecue = "documentStatusRecue",
  documentStatusValide = "documentStatusValide",
  documentStatusExpiree = "documentStatusExpiree",
  documentOptionalBadge = "documentOptionalBadge",
  documentUploadButton = "documentUploadButton",
  documentReplaceButton = "documentReplaceButton",
  documentUploadUnavailable = "documentUploadUnavailable",
  documentUploadInProgress = "documentUploadInProgress",
  documentUploadError = "documentUploadError",
  evidencePackContinueButton = "evidencePackContinueButton",
  evidencePackDetailAwaitingDecision = "evidencePackDetailAwaitingDecision",
  evidencePackDetailComplete = "evidencePackDetailComplete",
  evidencePackDetailHitConfirmed = "evidencePackDetailHitConfirmed",
  evidencePackDetailMissing = "evidencePackDetailMissing",
  evidencePackDetailNone = "evidencePackDetailNone",
  evidencePackDetailNotVerified = "evidencePackDetailNotVerified",
  evidencePackDetailPartial = "evidencePackDetailPartial",
  evidencePackDetailRestrictionsApplied = "evidencePackDetailRestrictionsApplied",
  evidencePackDetailVerified = "evidencePackDetailVerified",
  evidencePackHashLabel = "evidencePackHashLabel",
  evidencePackSectionAuditTrail = "evidencePackSectionAuditTrail",
  evidencePackSectionDecision = "evidencePackSectionDecision",
  evidencePackSectionDocuments = "evidencePackSectionDocuments",
  evidencePackSectionIdentification = "evidencePackSectionIdentification",
  evidencePackSectionRegistration = "evidencePackSectionRegistration",
  evidencePackSectionRepresentation = "evidencePackSectionRepresentation",
  evidencePackSectionRestrictions = "evidencePackSectionRestrictions",
  evidencePackSectionRiskScore = "evidencePackSectionRiskScore",
  evidencePackSectionScreening = "evidencePackSectionScreening",
  evidencePackSectionShareholding = "evidencePackSectionShareholding",
  evidencePackSectionStatusComplete = "evidencePackSectionStatusComplete",
  evidencePackSectionStatusMissing = "evidencePackSectionStatusMissing",
  evidencePackSectionStatusPartial = "evidencePackSectionStatusPartial",
  evidencePackSectionStatusVerified = "evidencePackSectionStatusVerified",
  mandateListEmpty = "mandateListEmpty",
  mandatePrincipalAlreadyExists = "mandatePrincipalAlreadyExists",
  mandateReason = "mandateReason",
  mandateRemoveConfirmDescription = "mandateRemoveConfirmDescription",
  mandateRemoveConfirmTitle = "mandateRemoveConfirmTitle",
  mandateRemoveFailed = "mandateRemoveFailed",
  mandateRemoveReasonLabel = "mandateRemoveReasonLabel",
  mandateRemoveReasonPlaceholder = "mandateRemoveReasonPlaceholder",
  mandateRemoveReasonRequired = "mandateRemoveReasonRequired",
  mandateRemoved = "mandateRemoved",
  mandateRole = "mandateRole",
  mandateRolePrincipal = "mandateRolePrincipal",
  mandateRoleSimple = "mandateRoleSimple",
  mandateSaveFailed = "mandateSaveFailed",
  mandateSaved = "mandateSaved",
  mandatesSectionTitle = "mandatesSectionTitle",
  pmOnboardingUnavailableDescription = "pmOnboardingUnavailableDescription",
  pmOnboardingUnavailableTitle = "pmOnboardingUnavailableTitle",
  pmScreeningFalsePositivePendingValidation = "pmScreeningFalsePositivePendingValidation",
  pmScreeningQualificationUncertain = "pmScreeningQualificationUncertain",
  pmScreeningStatusClear = "pmScreeningStatusClear",
  pmScreeningStatusHit = "pmScreeningStatusHit",
  pmScreeningStatusInconclusive = "pmScreeningStatusInconclusive",
  pmScreeningStatusPending = "pmScreeningStatusPending",
  riskFactorDigitalChannel = "riskFactorDigitalChannel",
  riskFactorForeignUbo = "riskFactorForeignUbo",
  riskFactorGafiNonCooperativeCountry = "riskFactorGafiNonCooperativeCountry",
  riskFactorHoldingStructure = "riskFactorHoldingStructure",
  riskFactorIntermediatePM = "riskFactorIntermediatePM",
  riskFactorYoungCompany = "riskFactorYoungCompany",
  riskLevelCritical = "riskLevelCritical",
  riskLevelHigh = "riskLevelHigh",
  riskLevelLow = "riskLevelLow",
  riskLevelStandard = "riskLevelStandard",
  understood = "understood",

  // Platform settings — module toggles reserved to the Box Africa editor persona
  platformSettings = "platformSettings",
  platformSettingsDescription = "platformSettingsDescription",
  kybModuleToggleTitle = "kybModuleToggleTitle",
  kybModuleToggleDescription = "kybModuleToggleDescription",
  kybModuleToggleEnabled = "kybModuleToggleEnabled",
  kybModuleToggleDisabled = "kybModuleToggleDisabled",
  kybModuleUnavailableTitle = "kybModuleUnavailableTitle",
  kybModuleUnavailableMessage = "kybModuleUnavailableMessage",
  identityPolicyToggleTitle = "identityPolicyToggleTitle",
  identityPolicyToggleDescription = "identityPolicyToggleDescription",
  screeningPolicyPepTitle = "screeningPolicyPepTitle",
  screeningPolicyPepDescription = "screeningPolicyPepDescription",
  screeningPolicyHighTitle = "screeningPolicyHighTitle",
  screeningPolicyHighDescription = "screeningPolicyHighDescription",
  screeningPolicyVneuroneModeLabel = "screeningPolicyVneuroneModeLabel",
  secretEncryptionTitle = "secretEncryptionTitle",
  secretEncryptionDescription = "secretEncryptionDescription",
  secretEncryptionInputLabel = "secretEncryptionInputLabel",
  secretEncryptionInputPlaceholder = "secretEncryptionInputPlaceholder",
  secretEncryptionButton = "secretEncryptionButton",
  secretEncryptionOutputLabel = "secretEncryptionOutputLabel",
  secretEncryptionCopy = "secretEncryptionCopy",
  secretEncryptionCopied = "secretEncryptionCopied",
  secretEncryptionError = "secretEncryptionError",
  screeningPolicyProviderLabel = "screeningPolicyProviderLabel",
  customerPurgeTitle = "customerPurgeTitle",
  customerPurgeDescription = "customerPurgeDescription",
  customerPurgeBusinessKeyLabel = "customerPurgeBusinessKeyLabel",
  customerPurgeBusinessKeyPlaceholder = "customerPurgeBusinessKeyPlaceholder",
  customerPurgeButton = "customerPurgeButton",
  customerPurgeConfirmTitle = "customerPurgeConfirmTitle",
  customerPurgeConfirmDescription = "customerPurgeConfirmDescription",
  customerPurgePasswordLabel = "customerPurgePasswordLabel",
  customerPurgePasswordPlaceholder = "customerPurgePasswordPlaceholder",
  customerPurgeConfirmButton = "customerPurgeConfirmButton",
  customerPurgeSuccess = "customerPurgeSuccess",
  customerPurgeError = "customerPurgeError",
  customerPurgeUnlockButton = "customerPurgeUnlockButton",
  customerPurgeLockedHint = "customerPurgeLockedHint",
  customerPurgeBusinessKeyInvalid = "customerPurgeBusinessKeyInvalid",

  // Agences — menu administration, lecture seule du referentiel des agences
  agences = "agences",
  agencesDescription = "agencesDescription",
  agenceCode = "agenceCode",
  agenceName = "agenceName",
  agenceCity = "agenceCity",
  agenceAddress = "agenceAddress",
  agenceContact = "agenceContact",
  agenceCoordinates = "agenceCoordinates",
  agenceHours = "agenceHours",
  agenceHoursOrdinary = "agenceHoursOrdinary",
  agenceHoursSaturday = "agenceHoursSaturday",
  agenceHoursSunday = "agenceHoursSunday",
  agenceEmptyState = "agenceEmptyState",
  agenceLoadError = "agenceLoadError",
  subscriptionChannel = "subscriptionChannel",
}

export default StringsKeys;
